import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { Rnd } from 'react-rnd';
import { useModalStore } from '../../state/modalStore';
import useTeamStore from '../../state/teamStore';
import { useProfileStore } from '../../state/profileStore';
import { useMessagingStore } from '../../state/messagingStore';
import { useConversationStore } from '../../state/conversationStore';
import { useMatrixStore } from '../../state/matrixStore';
import { useRecruitingStore } from '../../state/recruitingStore';
import useOtherUsersStore from '../../state/otherUsersStore';

import AllReviewsList from '../customers/AllReviewsList';
import ProfessionChecker from './ProfessionChecker';
import useMatrixClient, {
  getGlobalMatrixClient,
  getGlobalMatrixService,
  getGlobalMatrixReady,
} from '../../hooks/useMatrixClient';




export default function TeamModal() {
  const { teamOpen, teamId, closeTeam, openRecruiting } = useModalStore();
  const bringToFront = useModalStore((s) => s.bringToFront);
  const teamZ = useModalStore((s) => s.getZIndex('team'));
  const {
  myTeams,
  hydrateTeams,
  setActiveTeamId,
  ensureTeamMemberIds,
  teamMemberIdsByTeamId,
} = useTeamStore();

const { profile } = useProfileStore();

const {
  fetchByIds: fetchUsersByIds,
  getUser,
} = useOtherUsersStore();

const { loadTeamMeta, getTeamMeta, setTeamId: setRecruitingTeamId } = useRecruitingStore();

const {
  client: mxClient,
  service: mxService,
  isReady: isMatrixReady,
  error: mxError,
} = useMatrixClient();

const [pendingMatrixAccept, setPendingMatrixAccept] = useState(null);

// Profession Checker overlay (local to TeamModal for now)
const [professionCheckerOpen, setProfessionCheckerOpen] = useState(false);

// ===== ProfessionChecker → Ask the Team (captain-only) =====
const handleAskTeam = async ({ professionName }) => {
  try {
    console.log('[handleAskTeam] START', { professionName });
    
    const isCaptainNow = String(profileUser?.u_id) === String(captainId);
    if (!isCaptainNow) {
      console.log('[handleAskTeam] BLOCKED: Not captain');
      return;
    }

    const tId = Number(numericTeamId);
    if (!Number.isFinite(tId) || tId <= 0) {
      console.log('[handleAskTeam] BLOCKED: Invalid team ID', { numericTeamId });
      return;
    }

    console.log('[handleAskTeam] Looking for team room', { tId });

    // 1) Find the team room
    let roomId = null;
    const myMxid = typeof mxClient?.getUserId === 'function' ? mxClient.getUserId() : '';
    const domain = myMxid && myMxid.includes(':') ? myMxid.split(':')[1] : 'ehandshake.com';
    const aliasFull = `#t${tId}:${domain}`;

    console.log('[handleAskTeam] Matrix client state', {
      hasMxClient: !!mxClient,
      myMxid,
      domain,
      aliasFull,
      canGetRooms: typeof mxClient?.getRooms === 'function'
    });

    if (mxClient && typeof mxClient.getRooms === 'function') {
      const rooms = mxClient.getRooms() || [];
      console.log('[handleAskTeam] Total rooms available:', rooms.length);
      
      const hit = rooms.find((r) => {
        const canon = r.getCanonicalAlias?.() || '';
        if (String(canon) === aliasFull) return true;
        
        const aliases = r.getAliases?.() || [];
        if (aliases.some(a => String(a) === aliasFull)) return true;
        
        const name = r.name || '';
        if (String(name) === `Team ${tId}`) return true;
        
        return false;
      });
if (hit?.roomId) roomId = String(hit.roomId);
      
      console.log('[handleAskTeam] Room search result', {
        found: !!hit,
        roomId,
        searchedAlias: aliasFull,
        searchedName: `Team ${tId}`
      });
    }

    if (!roomId) {
      console.error('[handleAskTeam] FAILED: Could not find team room', {
        tId,
        aliasFull,
        mxClientAvailable: !!mxClient,
        totalRooms: mxClient?.getRooms?.()?.length || 0
      });
      alert('Could not find team room');
      return;
    }

    console.log('[handleAskTeam] SUCCESS: Found room', roomId);

// 2) Close modal and open chat FIRST (instant UI response)
    console.log('[handleAskTeam] Closing modal and opening chat');
    closeTeam();
    
    const mx = useMatrixStore.getState();
    if (mx?.setSelectedRoomId) mx.setSelectedRoomId(roomId);
    if (mx?.open) mx.open();
    
    if (typeof bringToFront === 'function') {
      bringToFront('chat');
    }

// 3) Send message in background (don't wait)
    console.log('[handleAskTeam] Preparing to send message');
    const focusRaw = (profileUser?.u_customer_focus || '').toString().trim().toUpperCase();
    const focus = focusRaw || 'B2B/B2C/B2BC';
    const p = (professionName || '').toString().trim() || 'teammate';
    const msg = `Hello everyone. We are looking for new businesses for our team.\n\nIf anyone knows an exceptional ${p}, please ask them to join eHandshake and search for me or the team.\n\nRemember, we are a ${focus} team.`;

if (mxService && typeof mxService.sendMessage === 'function') {
      console.log('[handleAskTeam] Sending via mxService');
      mxService.sendMessage(roomId, msg)
        .then(() => console.log('[handleAskTeam] Message sent successfully'))
        .catch(err => console.error('[handleAskTeam] Message send failed:', err));
    } else if (mxClient && typeof mxClient.sendTextMessage === 'function') {
      console.log('[handleAskTeam] Sending via mxClient');
      mxClient.sendTextMessage(roomId, msg)
        .then(() => console.log('[handleAskTeam] Message sent successfully'))
        .catch(err => console.error('[handleAskTeam] Message send failed:', err));
    } else {
      console.error('[handleAskTeam] No send method available', {
        hasMxService: !!mxService,
        hasMxClient: !!mxClient
      });
    }

  } catch (err) {
    console.error('[TeamModal] Ask the Team failed:', err);
  }
};


  const [teamMeta, setTeamMeta] = useState(null);



  const [teamRating, setTeamRating] = useState({
    avg: null,
    count: 0,
    memberCount: 1, // captain-only for now
  });

  const [captainBusiness, setCaptainBusiness] = useState({
    companyName: '',
    industry: '',
  });

  const openCandidate = useModalStore((s) => s.openCandidate);
  const viewerUId = Number(window.localStorage.getItem('u_id')) || null;

  // Data
  const [userCenter, setUserCenter] = useState(null);

  // ZIP → lat/lng fallback (lightweight, local file you host at /data/zip-centroids.min.json)
  let ZIP_DICT = null;
  async function zipToLatLng(zip) {
    const z = String(zip || '').slice(0, 5);
    if (!z) return null;
    if (!ZIP_DICT) {
      try {
        const resp = await fetch('/data/zip-centroids.min.json');
        ZIP_DICT = await resp.json(); // { "94103":[37.7725,-122.4091], ...}
      } catch {
        return null;
      }
    }
    const hit = ZIP_DICT[z];
    return hit ? { lat: hit[0], lng: hit[1] } : null;
  }

  // Geocode a full street address (cached). Keep it simple & reliable.
  const geocodeCache = useRef(new Map());
  async function geocodeAddress({ street, city, state, zip }) {
    const zip5 = (zip || '').toString().replace(/\D/g, '').slice(0, 5);
    const addressStr = [String(street || '').trim(), String(city || '').trim(), String(state || '').trim(), zip5]
      .filter(Boolean)
      .join(', ');
    const key = addressStr;
    if (!key) return null;

    if (geocodeCache.current.has(key)) return geocodeCache.current.get(key);

    const g = window.google?.maps;
    if (!g?.Geocoder) return null;

    // 1) Try the full address string (most robust)
    const result = await new Promise((resolve) => {
      const geocoder = new g.Geocoder();
      geocoder.geocode({ address: addressStr }, (results, status) => {
        if (status === 'OK' && results?.[0]?.geometry?.location) {
          const loc = results[0].geometry.location;
          resolve({ lat: loc.lat(), lng: loc.lng() });
        } else {
          resolve(null);
        }
      });
    });

    // 2) If that fails, try a minimal “street + ZIP” form
    let finalResult = result;
    if (!finalResult && String(street || '').trim() && zip5) {
      finalResult = await new Promise((resolve) => {
        const geocoder = new g.Geocoder();
        geocoder.geocode({ address: `${String(street).trim()}, ${zip5}` }, (results, status) => {
          if (status === 'OK' && results?.[0]?.geometry?.location) {
            const loc = results[0].geometry.location;
            resolve({ lat: loc.lat(), lng: loc.lng() });
          } else {
            resolve(null);
          }
        });
      });
    }

    geocodeCache.current.set(key, finalResult);
    return finalResult;
  }

  // resolve user center (DB coords → ZIP centroid → ADDRESS geocode; no US fallback)
  useEffect(() => {
    (async () => {
      const zip5 = (profile?.b_zip_code || '').toString().replace(/\D/g, '').slice(0, 5);
      const street = (profile?.b_address || '').toString().trim();
      const city   = (profile?.b_city || '').toString().trim();
      const state  = (profile?.b_state || '').toString().trim();

      // 1) Exact business coords (DB) if present (fast, no Maps API needed)
      if (profile?.b_lat != null && profile?.b_lng != null) {
        setUserCenter({ lat: +profile.b_lat, lng: +profile.b_lng });
        return;
      }

      // 2) ZIP centroid (fast local lookup)
      if (zip5) {
        const byZip = await zipToLatLng(zip5);
        if (byZip) {
          setUserCenter(byZip);
          return;
        }
      }

      // 3) Full address geocode (requires Google Maps Geocoder)
      if (street && (city || state || zip5)) {
        const byAddr = await geocodeAddress({ street, city, state, zip: zip5 });
        if (byAddr) {
          setUserCenter(byAddr);
          return;
        }
      }

      // 4) No fallback to US center — keep userCenter null so the map doesn’t mount and flicker.
      // The GoogleMap only renders when userCenter is truthy, so no Kansas flash.
    })();
  }, [
    profile?.b_address,
    profile?.b_city,
    profile?.b_state,
    profile?.b_zip_code,
    profile?.b_lat,
    profile?.b_lng
  ]);

  // TEMP: Invite banner payload (later will come from Matrix message / invite record)
  // localStorage key: "eh_team_invite_banner"
  // expected shape:
  // { mode: "incoming", invitee_u_id: 123, invitee_name: "Jane Doe" }
  const [inviteBanner, setInviteBanner] = useState(null);
  const [inviteAccepted, setInviteAccepted] = useState(false);
  const [buildingTeammateCard, setBuildingTeammateCard] = useState(false);
  const [inviteAcceptLoading, setInviteAcceptLoading] = useState(false);
  const [inviteAcceptError, setInviteAcceptError] = useState('');

  const [showDeclineReason, setShowDeclineReason] = useState(false);
  const [declineReason, setDeclineReason] = useState('');
  const [inviteDeclineLoading, setInviteDeclineLoading] = useState(false);

  // Payment-gated join state
  const [paymentGate, setPaymentGate] = useState(null); // { required_tier, current_tier, team_id, invite_token, inviter_u_id }
  const paymentPollRef = useRef(null);

  // Poll invite status after checkout — clears banner when webhook auto-joins
  // Pass all needed values as params to avoid temporal dead zone issues with hooks
  const startPaymentPoll = (token, uid, { inviterUId, inviteeName, tName } = {}) => {
    if (paymentPollRef.current) clearInterval(paymentPollRef.current);
    paymentPollRef.current = setInterval(async () => {
      try {
        const res = await fetch('/api/teams/invite/status', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'include',
          body: JSON.stringify({ invite_token: token, invitee_u_id: uid }),
        });
        const data = await res.json();
        if (data?.invite_status === 'accepted' || data?.invite_accepted) {
          clearInterval(paymentPollRef.current);
          paymentPollRef.current = null;

          // Send DM acceptance message via Matrix client
          try {
            const name = inviteeName || 'A new member';
            const team = tName || 'the team';
            const message = `${name} has joined the team ${team}.`;
            const roomId = data?.dm_room_id;
            if (roomId && message) {
              const effectiveService = getGlobalMatrixService();
              const effectiveClient = getGlobalMatrixClient();
              if (effectiveService && typeof effectiveService.sendMessage === 'function') {
                await effectiveService.sendMessage(roomId, message);
                console.log('[TeamModal] Payment poll: DM message sent via service');
              } else if (effectiveClient && typeof effectiveClient.sendEvent === 'function') {
                await effectiveClient.sendEvent(roomId, 'm.room.message', { msgtype: 'm.text', body: message });
                console.log('[TeamModal] Payment poll: DM message sent via client');
              }
            }
          } catch (dmErr) {
            console.error('[TeamModal] Payment poll: DM error (non-fatal):', dmErr.message);
          }

          setPaymentGate(null);
          setInviteBanner(null);
          setInviteAccepted(true);
          localStorage.removeItem('eh_team_invite_banner');
          if (hydrateTeams) hydrateTeams();
        }
      } catch {}
    }, 3000);
  };

  // Cleanup polling on unmount
  useEffect(() => () => { if (paymentPollRef.current) clearInterval(paymentPollRef.current); }, []);

  const modalRef = useRef(null);

  // DEBUG: prove whether TeamModal is mounted more than once
  const instanceIdRef = useRef(
    `TM_${Date.now()}_${Math.random().toString(16).slice(2)}`
  );

  // Prevent repeated “invite prefetch” loops for the same team_id
  const invitePrefetchTeamIdRef = useRef(null);


  // --- Window controls (Windows-style) ---
  // "normal" = default size/position (your current state)
  // "max"    = fills viewport body area (leaves header/footer visible)
  const [windowMode, setWindowMode] = useState('normal'); // 'normal' | 'max'
  const [windowRect, setWindowRect] = useState(null); // { width, height, x, y }

  const getHeaderFooterOffsets = () => {
    // Best-effort: use <header>/<footer> if present, otherwise no offsets.
    // This keeps the modal from covering your app header/footer.
    const headerEl = document.querySelector('header');
    const footerEl = document.querySelector('footer');

    const headerH = headerEl ? Math.ceil(headerEl.getBoundingClientRect().height || 0) : 0;
    const footerH = footerEl ? Math.ceil(footerEl.getBoundingClientRect().height || 0) : 0;

    return { headerH, footerH };
  };

  const getMaxRect = () => {
    const { headerH, footerH } = getHeaderFooterOffsets();

    const w = Math.max(600, window.innerWidth);
    const h = Math.max(400, window.innerHeight - headerH - footerH);

    return {
      width: w,
      height: h,
      x: 0,
      y: headerH,
    };
  };

  const getNormalRect = () => {
    // Fixed “first open” size: centered, and clamped to viewport so it never bleeds off-screen.
    const padding = 16;

  const TARGET_WIDTH = 800;
  const MIN_HEIGHT = 520;

  const w = Math.min(
    TARGET_WIDTH,
    window.innerWidth - padding * 2
  );

  const h = Math.max(
    MIN_HEIGHT,
    Math.min(
      Math.floor(window.innerHeight * 0.85),
      window.innerHeight - padding * 2
    )
  );


    let x = Math.floor((window.innerWidth - w) / 2);
    let y = Math.floor((window.innerHeight - h) / 2);

    // Clamp position so the window always stays in-bounds.
    x = Math.max(padding, Math.min(x, window.innerWidth - w - padding));
    y = Math.max(padding, Math.min(y, window.innerHeight - h - padding));

    return { width: w, height: h, x, y };
  };

  // Always reset to a fixed, safe normal size/position on open.
  // This prevents occasional “elongated/off-screen” opens caused by persisted windowRect in a globally mounted modal.
  useEffect(() => {
    if (!teamOpen) return;

    setWindowMode('normal');
    setWindowRect(getNormalRect());
  }, [teamOpen, teamId]);


const toggleMaximize = () => {
  if (windowMode === 'max') {
    // restore to last known normal rect
    setWindowMode('normal');
    return;
  }

  // maximize — capture current rect before expanding
  if (modalRef.current) {
    const node = modalRef.current.resizableElement?.current;
    if (node) {
      const rect = node.getBoundingClientRect();
      setWindowRect({
        width: Math.round(rect.width),
        height: Math.round(rect.height),
        x: Math.round(rect.left),
        y: Math.round(rect.top),
      });
    }
  }

  setWindowMode('max');
};


  const onMinimizeClick = () => {
    // In your spec: "_" does nothing in normal (already "minimized"),
    // but restores when maximized.
    if (windowMode === 'max') {
      setWindowMode('normal');
    }
  };


  const starCount = 5;
  const activeStars =
    teamRating.avg != null
      ? Math.round(
          Math.max(0, Math.min(starCount, Number(teamRating.avg) || 0))
        )
      : 0;

  const numericTeamId = Number(teamId);
  const currentTeam =
    Array.isArray(myTeams) && Number.isFinite(numericTeamId)
      ? myTeams.find((t) => Number(t?.team_id) === numericTeamId)
      : null;


  // Use the store as the single source for profile in this file (TeamInfo pattern)
  const profileUser = profile;

  const [nearbyUsers, setNearbyUsers] = useState([]);
  const [nearbyLoading, setNearbyLoading] = useState(false);

  // Active layer (IDENTICAL to TeamInfo)
  const [activeLayer, setActiveLayer] = useState('candidates');
  const isCustomers  = activeLayer === 'customers';
  const isCandidates = activeLayer === 'candidates';
  const isLocal      = activeLayer === 'local' || activeLayer === 'teams';

  // Right Column tab (Design A)
  const [rightTab, setRightTab] = useState('reviews'); // 'reviews' | 'activity'
  const isRightReviews = rightTab === 'reviews';
  const isRightActivity = rightTab === 'activity';
  // Team Reviews (aggregate feed for Column 3)
  const [teamReviewsByUserId, setTeamReviewsByUserId] = useState({});
  const [teamReviewsLoading, setTeamReviewsLoading] = useState(false);

  // Team Activity — server-paged feed (joins + shares)
  const TEAM_ACTIVITY_PAGE_SIZE = 20;
  const [teamActivityEvents, setTeamActivityEvents] = useState([]);
  const [teamActivityLoading, setTeamActivityLoading] = useState(false);
  const [teamActivityCursor, setTeamActivityCursor] = useState(null);
  const [teamActivityHasMore, setTeamActivityHasMore] = useState(true);

  const [captainSocialPlatforms, setCaptainSocialPlatforms] = useState([]);

  const teamActivityScrollRef = useRef(null);
  const teamActivitySentinelRef = useRef(null);

// 2C — fetch nearby users when "Find Teammates" is active (IDENTICAL to TeamInfo)
  useEffect(() => {
    if (!teamOpen) return;

    const focus = (profileUser?.u_customer_focus || '').toUpperCase();
    console.log('[TeamModal local-users gate]', { activeLayer, userCenter, focus });
    if (activeLayer !== 'candidates' || !userCenter || !focus) return;

    let cancel = false;

    (async () => {
      try {
        setNearbyLoading(true);

        const url =
          `/api/profile/teams/local-users?focus=${encodeURIComponent(focus)}` +
          `&lat=${userCenter.lat}&lng=${userCenter.lng}&radius=100`;

        const resp = await fetch(url, { credentials: 'include' });
        const data = resp.ok ? await resp.json() : [];

        if (!cancel) {
          const arr = Array.isArray(data) ? data : [];
          // Seed the SAME rich objects into the global store (TeamInfo behavior)
          useOtherUsersStore.getState().seedFromArray(arr);
          setNearbyUsers(arr);
        }
      } catch (e) {
        if (!cancel) setNearbyUsers([]);
      } finally {
        if (!cancel) setNearbyLoading(false);
      }
    })();

    return () => { cancel = true; };
  }, [teamOpen, activeLayer, userCenter, profileUser?.u_customer_focus]);


  // Prefer freshly loaded meta, fall back to cached teamMeta in recruitingStore
  const cachedMeta =
    Number.isFinite(numericTeamId) ? getTeamMeta(numericTeamId) : null;
  const effectiveMeta = teamMeta || cachedMeta || null;
  const captain = effectiveMeta?.captain || null;
  const teamSlug =
  (effectiveMeta?.team?.team_slug
    ? String(effectiveMeta.team.team_slug).trim()
    : '') ||
  (effectiveMeta?.team_slug
    ? String(effectiveMeta.team_slug).trim()
    : '') ||
  (currentTeam?.team_slug
    ? String(currentTeam.team_slug).trim()
    : '');
  const teamName =
    (effectiveMeta?.team?.team_name
      ? String(effectiveMeta.team.team_name).trim()
      : '') ||
    (effectiveMeta?.team_name ? String(effectiveMeta.team_name).trim() : '') ||
    (currentTeam?.team_name ? String(currentTeam.team_name).trim() : '') ||
    (Number.isFinite(numericTeamId) ? `Team ${numericTeamId}` : '');


  // Captain name:
  // 1) captain.full_name or first/last from recruitingStore
  // 2) owner_* stamped on the team (if viewer owns it)
  // 3) signed-in viewer's name
  // 4) fallback "Captain"
  const captainName =
    (captain?.full_name ||
      [captain?.first_name, captain?.last_name].filter(Boolean).join(' ').trim()) ||
    [currentTeam?.owner_first_name, currentTeam?.owner_last_name]
      .filter(Boolean)
      .join(' ')
      .trim() ||
    [profileUser?.u_first_name, profileUser?.u_last_name]
      .filter(Boolean)
      .join(' ')
      .trim() ||
    'Captain';

  // Captain id for rating-summary:
  // 1) captain.u_id from recruitingStore team-meta
  // 2) team.captain_u_id or owner_u_id from teamStore
  // 3) viewer's u_id from profileStore
  const captainId =
    captain?.u_id ??
    currentTeam?.captain_u_id ??
    currentTeam?.owner_u_id ??
    profileUser?.u_id ??
    null;

  const teamMembers =
    Number.isFinite(numericTeamId) && Array.isArray(teamMemberIdsByTeamId?.[numericTeamId])
      ? teamMemberIdsByTeamId[numericTeamId]
          .filter((u_id) => !captainId || String(u_id) !== String(captainId))
          .map((u_id) => {
            const id = Number(u_id);
            if (Number.isFinite(id) && Number(id) === Number(profileUser?.u_id)) return profileUser;
            return getUser(u_id);
          })
          .filter(Boolean)
      : [];

  // All member ids for Team Reviews (captain + all teammates)
  const allTeamMemberIds = useMemo(() => {
    const idsRaw =
      Number.isFinite(numericTeamId) && Array.isArray(teamMemberIdsByTeamId?.[numericTeamId])
        ? teamMemberIdsByTeamId[numericTeamId]
        : [];

    const combined = [
      captainId,
      ...idsRaw,
    ];

    // Normalize + dedupe
    const uniq = [];
    const seen = new Set();

    for (const x of combined) {
      const n = Number(x);
      if (!Number.isFinite(n) || n <= 0) continue;
      if (seen.has(n)) continue;
      seen.add(n);
      uniq.push(n);
    }

    return uniq;
  }, [numericTeamId, teamMemberIdsByTeamId, captainId]);

  // Fetch captain's social platforms (ever connected)
  useEffect(() => {
    const id = Number(captainId);
    if (!Number.isFinite(id) || id <= 0) return;
    let cancelled = false;
    (async () => {
      try {
        const resp = await fetch(`/api/social/platforms/${id}`, { credentials: 'include' });
        const data = await resp.json();
        if (!cancelled && data.ok) setCaptainSocialPlatforms(data.platforms || []);
      } catch (err) {
        console.error('[TeamModal] captain social platforms fetch error:', err);
      }
    })();
    return () => { cancelled = true; };
  }, [captainId]);

  // ProfessionChecker needs the full roster (captain + teammates)
  const rosterForProfessionChecker = useMemo(() => {
    const ids = Array.isArray(allTeamMemberIds) ? allTeamMemberIds : [];
    return ids
      .map((u_id) => {
        const id = Number(u_id);
        if (!Number.isFinite(id)) return null;

        // If the signed-in user is on the roster, use profileUser
        if (Number(id) === Number(profileUser?.u_id)) return profileUser;

        // Otherwise pull from otherUsers store
      const u = getUser(id);

      if (!u) {
        console.log('[professionchecker] roster missing getUser', { id });
      }

      return u;

      })


      
      .filter(Boolean);
  }, [allTeamMemberIds, getUser, profileUser]);


  // Sort helper (newest first)
  const getReviewTs = (r) => {
    const s =
      r?.customersurvey_created_at ||
      r?.customersurvey_google_created_at ||
      r?.created_at ||
      r?.date ||
      null;

    const d = s ? new Date(s) : null;
    const t = d && !isNaN(d) ? d.getTime() : 0;
    return t;
  };

  // Flatten + sort the aggregated feed
  const teamReviewsSorted = useMemo(() => {
    const merged = [];

    for (const uid of allTeamMemberIds) {
      const arr = teamReviewsByUserId?.[uid];
      if (!Array.isArray(arr) || arr.length === 0) continue;

      for (const r of arr) {
        // Ensure the feed can attribute the review to a teammate
        merged.push({
          ...r,
          user_id: r?.user_id ?? r?.u_id ?? uid,
        });
      }
    }

    merged.sort((a, b) => getReviewTs(b) - getReviewTs(a));
    return merged;
  }, [allTeamMemberIds, teamReviewsByUserId]);

  // Infinite scroll (sentinel) — load 7 at a time inside the reviews column
  const TEAM_REVIEWS_PAGE_SIZE = 7;
  const [teamReviewsVisibleCount, setTeamReviewsVisibleCount] = useState(TEAM_REVIEWS_PAGE_SIZE);
  const teamReviewsScrollRef = useRef(null);
  const teamReviewsSentinelRef = useRef(null);

  // Reset paging when switching teams / reopening / switching tabs
  useEffect(() => {
    if (!teamOpen) return;
    if (!isRightReviews) return;
    setTeamReviewsVisibleCount(TEAM_REVIEWS_PAGE_SIZE);
  }, [teamOpen, numericTeamId, isRightReviews]);

  const teamReviewsVisible = useMemo(() => {
    return teamReviewsSorted.slice(0, teamReviewsVisibleCount);
  }, [teamReviewsSorted, teamReviewsVisibleCount]);

  useEffect(() => {
    if (!teamOpen) return;
    if (!isRightReviews) return;

    const rootEl = teamReviewsScrollRef.current;
    const sentinelEl = teamReviewsSentinelRef.current;

    if (!rootEl || !sentinelEl) return;
    if (teamReviewsVisibleCount >= teamReviewsSorted.length) return;

    const obs = new IntersectionObserver(
      (entries) => {
        const first = entries && entries[0];
        if (!first || !first.isIntersecting) return;

        setTeamReviewsVisibleCount((prev) =>
          Math.min(prev + TEAM_REVIEWS_PAGE_SIZE, teamReviewsSorted.length)
        );
      },
      {
        root: rootEl,
        rootMargin: '0px 0px 140px 0px',
        threshold: 0.01,
      }
    );

    obs.observe(sentinelEl);

    return () => {
      try {
        obs.disconnect();
      } catch (e) {}
    };
  }, [
    teamOpen,
    isRightReviews,
    teamReviewsVisibleCount,
    teamReviewsSorted.length,
  ]);


  // Activity — reset when switching teams / reopening / switching tabs
  useEffect(() => {
    if (!teamOpen) return;
    if (!isRightActivity) return;

    setTeamActivityEvents([]);
    setTeamActivityCursor(null);
    setTeamActivityHasMore(true);
  }, [teamOpen, numericTeamId, isRightActivity]);

  const fetchTeamActivityPage = async (cursorOrNull) => {
    if (!teamOpen) return;
    if (!Number.isFinite(numericTeamId) || numericTeamId <= 0) return;

    // Prevent duplicate parallel loads
    if (teamActivityLoading) return;

    setTeamActivityLoading(true);

    try {
      const qs = new URLSearchParams();
      qs.set('limit', String(TEAM_ACTIVITY_PAGE_SIZE));
      if (cursorOrNull) qs.set('cursor', String(cursorOrNull));

      const resp = await fetch(`/api/teams/${numericTeamId}/activity?${qs.toString()}`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
      });

      const data = await resp.json();

      if (!resp.ok || !data?.ok) {
        console.error('[TeamModal activity] fetch failed:', { status: resp.status, data });
        return;
      }

      const incoming = Array.isArray(data.events) ? data.events : [];

      // Hydrate actor users + target users (best-effort, using your existing pattern)
      try {
        const idSet = new Set();
        for (const e of incoming) {
          const actorId = Number(e?.actor_u_id);
          if (Number.isFinite(actorId) && actorId > 0) idSet.add(actorId);
          // Also hydrate target_u_id (e.g. creation author) for share events
          const targetId = Number(e?.payload?.target_u_id);
          if (Number.isFinite(targetId) && targetId > 0) idSet.add(targetId);
        }

        const missing = Array.from(idSet).filter((id) => {
          if (Number(id) === Number(profileUser?.u_id)) return false;
          const u = getUser(id);
          return !u;
        });

        if (missing.length > 0) {
          await fetchUsersByIds(missing);
        }
      } catch (e) {
        // non-fatal
      }

      setTeamActivityEvents((prev) => {
        const prevArr = Array.isArray(prev) ? prev : [];
        const merged = cursorOrNull ? [...prevArr, ...incoming] : incoming;

        // Deduplicate by event_id (defensive)
        const seen = new Set();
        const out = [];
        for (const ev of merged) {
          const id = String(ev?.event_id ?? '');
          if (!id) continue;
          if (seen.has(id)) continue;
          seen.add(id);
          out.push(ev);
        }
        return out;
      });

      setTeamActivityCursor(data?.nextCursor ?? null);
      setTeamActivityHasMore(Boolean(data?.hasMore));
    } catch (err) {
      console.error('[TeamModal activity] fetch error:', err);
    } finally {
      setTeamActivityLoading(false);
    }
  };

  // Activity — initial page on open/tab
  useEffect(() => {
    if (!teamOpen) return;
    if (!isRightActivity) return;

    // If reset has occurred, events will be empty and hasMore true
    if (teamActivityEvents.length === 0 && teamActivityHasMore) {
      fetchTeamActivityPage(null);
    }
  }, [teamOpen, isRightActivity, numericTeamId]);

  // Activity — infinite scroll (cursor pagination)
  useEffect(() => {
    if (!teamOpen) return;
    if (!isRightActivity) return;

    const rootEl = teamActivityScrollRef.current;
    const sentinelEl = teamActivitySentinelRef.current;

    if (!rootEl || !sentinelEl) return;
    if (!teamActivityHasMore) return;
    if (teamActivityLoading) return;

    const obs = new IntersectionObserver(
      (entries) => {
        const first = entries && entries[0];
        if (!first || !first.isIntersecting) return;

        if (!teamActivityHasMore) return;
        if (teamActivityLoading) return;

        fetchTeamActivityPage(teamActivityCursor);
      },
      {
        root: rootEl,
        rootMargin: '0px 0px 140px 0px',
        threshold: 0.01,
      }
    );

    obs.observe(sentinelEl);

    return () => {
      try {
        obs.disconnect();
      } catch (e) {}
    };
  }, [
    teamOpen,
    isRightActivity,
    teamActivityCursor,
    teamActivityHasMore,
    teamActivityLoading,
    teamActivityEvents.length,
  ]);



  // Captain photo:
  // 1) captain.u_profile_picture (from recruitingStore team-meta)
  // 2) owner_profile_picture stamped by teamStore.hydrateTeams (if viewer owns team)
  // 3) viewer's u_profile_picture from profileStore
  const rawCaptainPhoto =

    captain?.u_profile_picture ||
    currentTeam?.owner_profile_picture ||
    profileUser?.u_profile_picture ||
    '';

  const captainProfile = rawCaptainPhoto
    ? `${process.env.REACT_APP_API_URL}${rawCaptainPhoto}`
    : '';

  // Business name + industry should reflect the CAPTAIN (not the signed-in viewer)
  const captainRichFromLocalUsers =
    (Array.isArray(nearbyUsers)
      ? nearbyUsers.find((u) => Number(u?.u_id) === Number(captainId))
      : null) || null;

  const companyName =
    captainRichFromLocalUsers?.b_name ||
    captainRichFromLocalUsers?.business?.b_name ||
    '';

  const industry =
    // ✅ If the captain is SELF, nearbyUsers often excludes self — so use profileUser
    (Number(profileUser?.u_id) === Number(captainId)
      ? (profileUser?.b_business_industry ||
        profileUser?.b_industry ||
        profileUser?.business?.b_business_industry ||
        profileUser?.business?.b_industry ||
        '')
      : '') ||
    // ✅ Otherwise use the rich local-users object (teammate case)
    captainRichFromLocalUsers?.b_business_industry ||
    captainRichFromLocalUsers?.business?.b_business_industry ||
    captainRichFromLocalUsers?.b_industry ||
    captainRichFromLocalUsers?.business?.b_industry ||
    '';




  // close on ESC when open
  useEffect(() => {
    if (!teamOpen) return;
    const onKey = (e) => e.key === 'Escape' && closeTeam();
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [teamOpen, closeTeam]);

  // DEBUG: fire on every open (not just mount)
  useEffect(() => {
    if (!teamOpen) return;
    bringToFront('team');

    console.log('[TeamModal] OPEN', instanceIdRef.current, { teamId });
    console.trace('[TeamModal] OPEN TRACE', instanceIdRef.current);

    return () => {
      console.log('[TeamModal] CLOSE', instanceIdRef.current, { teamId });
    };
  }, [teamOpen, teamId, bringToFront]);

useEffect(() => {
  if (!pendingMatrixAccept) return;

  const effectiveReady = Boolean(isMatrixReady) || getGlobalMatrixReady();
  const effectiveService = mxService || getGlobalMatrixService();

  if (!effectiveReady || !effectiveService) return;

  const roomId = String(pendingMatrixAccept?.room_id || '').trim();
  const message = String(pendingMatrixAccept?.message || '').trim();

  if (!roomId || !message) {
    console.warn('[TeamModal] Matrix accept payload invalid; not sending', {
      hasRoomId: Boolean(roomId),
      hasMessage: Boolean(message),
    });
    setPendingMatrixAccept(null);
    return;
  }

  let cancelled = false;

  (async () => {
    try {
      await effectiveService.sendMessage(roomId, message);

      if (!cancelled) {
        console.log('[TeamModal] Matrix accept message sent', { roomId });
        setPendingMatrixAccept(null);
      }
    } catch (err) {
      console.error('[TeamModal] Matrix accept send failed', err);
      // Keep pendingMatrixAccept intact so it can retry if Matrix reconnects.
    }
  })();

  return () => {
    cancelled = true;
  };
}, [pendingMatrixAccept, isMatrixReady, mxService]);




  // Load { team, captain } meta for this team when the modal is open
  useEffect(() => {
    if (!teamOpen) return;
    if (!Number.isFinite(numericTeamId)) return;

    let cancelled = false;

    (async () => {
      try {
        const meta = await loadTeamMeta(numericTeamId);
        if (!cancelled) {
          setTeamMeta(meta || null);
        }
      } catch (err) {
        console.error('[TeamModal] loadTeamMeta error:', err);
        if (!cancelled) {
          setTeamMeta(null);
        }
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [teamOpen, numericTeamId, loadTeamMeta]);

  // Load captain business info for Column 1 (company name + industry)
useEffect(() => {
    if (!teamOpen) return;
    if (!Number.isFinite(numericTeamId)) return;

    let cancelled = false;

    (async () => {
      try {
        const res = await fetch(
          `/api/teams/ratings/summary?team_id=${numericTeamId}`,
          { credentials: 'include' }
        );
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const data = await res.json();

        if (cancelled) return;

        const avgRaw =
          data && data.team_avg != null ? parseFloat(data.team_avg) : null;
        const avg = Number.isFinite(avgRaw) ? avgRaw : null;

        const countRaw =
          data && data.team_review_count != null
            ? Number(data.team_review_count)
            : 0;
        const count = Number.isFinite(countRaw) ? countRaw : 0;

        const memberCountRaw =
          data && data.member_count_total != null
            ? Number(data.member_count_total)
            : 0;
        const memberCount = Number.isFinite(memberCountRaw) ? memberCountRaw : 0;

        setTeamRating({
          avg: count > 0 ? avg : null, // enforce “exclude no-ratings”
          count,
          memberCount,
        });
      } catch (err) {
        console.error('[TeamModal] load team rating summary error:', err);
        if (!cancelled) {
          setTeamRating({
            avg: null,
            count: 0,
            memberCount: 0,
          });
        }
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [teamOpen, numericTeamId]);


  // Load TEAM rating summary (weighted across captain + all teammates)
  useEffect(() => {
    if (!teamOpen) return;
    if (!Number.isFinite(numericTeamId)) return;

    let cancelled = false;

    (async () => {
      try {
        const res = await fetch(
          `/api/teams/ratings/summary?team_id=${numericTeamId}`,
          { credentials: 'include' }
        );
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const data = await res.json();

        if (cancelled) return;

        const avgRaw =
          data && data.team_avg != null ? parseFloat(data.team_avg) : null;
        const avg = Number.isFinite(avgRaw) ? avgRaw : null;

        const countRaw =
          data && data.team_review_count != null
            ? Number(data.team_review_count)
            : 0;
        const count = Number.isFinite(countRaw) ? countRaw : 0;

        const memberCountRaw =
          data && data.member_count_total != null
            ? Number(data.member_count_total)
            : 0;
        const memberCount = Number.isFinite(memberCountRaw) ? memberCountRaw : 0;

        setTeamRating({
          avg: count > 0 ? avg : null, // hide avg if no reviews in pool
          count,
          memberCount,
        });
      } catch (err) {
        console.error('[TeamModal] load team rating summary error:', err);
        if (!cancelled) {
          setTeamRating({
            avg: null,
            count: 0,
            memberCount: 0,
          });
        }
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [teamOpen, numericTeamId]);


  // DEBUG (temporary): inspect where team membership lives
  useEffect(() => {
    if (!teamOpen) return;
    if (!currentTeam) return;

    console.group('[TeamModal] currentTeam inspection');
    console.log('currentTeam:', currentTeam);
    console.log('keys:', Object.keys(currentTeam || {}));

    if (Array.isArray(currentTeam.members)) {
      console.log('members[] found:', currentTeam.members);
    }

    if (Array.isArray(currentTeam.team_members)) {
      console.log('team_members[] found:', currentTeam.team_members);
    }

    if (Array.isArray(currentTeam.users)) {
      console.log('users[] found:', currentTeam.users);
    }

    console.groupEnd();
  }, [teamOpen, currentTeam]);

  // Prevent scroll bleed while open (match ChatCenter behavior)
useEffect(() => {
  if (!teamOpen) return;

  const prev = document.body.style.overflow;
  document.body.style.overflow = 'hidden';

  // Load invite banner payload when modal opens.
  // - If you're already a member of this team, ignore + delete any stale invite banner.
  // - Only show incoming invite banners that match this user + this team.
  try {
    const key = 'eh_team_invite_banner';
    const raw = localStorage.getItem(key);

    const currentUserId = Number(profile?.u_id);
    // Only treat as "already member" if they have an active role (not just cached data)
    const membershipRow = Array.isArray(myTeams) && Number.isFinite(numericTeamId)
      ? myTeams.find((t) => Number(t?.team_id) === numericTeamId)
      : null;
    const alreadyMember = !!membershipRow;

    console.log('[TeamModal] invite banner check', {
      teamOpen, numericTeamId, currentUserId,
      alreadyMember, hasRaw: !!raw, raw,
      membershipRow: membershipRow ? { team_id: membershipRow.team_id, role: membershipRow.role } : null,
    });

    if (alreadyMember) {
      // Already on this team — clear any stale invite banner
      console.log('[TeamModal] clearing banner — already a member');
      localStorage.removeItem(key);
      setInviteBanner(null);
      setPaymentGate(null);
    } else if (raw) {
      const parsed = JSON.parse(raw);

      const parsedModeOk = parsed && parsed.mode === 'incoming';
      const parsedTeamOk =
        !parsed?.team_id || Number(parsed.team_id) === Number(numericTeamId);
      const parsedUserOk =
        !parsed?.invitee_u_id ||
        (Number.isFinite(currentUserId) && Number(parsed.invitee_u_id) === currentUserId);

      console.log('[TeamModal] banner validation', { parsedModeOk, parsedTeamOk, parsedUserOk, parsed });

      if (parsedModeOk && parsedTeamOk && parsedUserOk) {
        console.log('[TeamModal] ✅ setting invite banner');
        setInviteBanner(parsed);
      }
    }
  } catch (err) {
    console.error('[TeamModal] banner parse error', err);
  }

  return () => {
    document.body.style.overflow = prev;
    // Only clean up banner ref on unmount, not on every dependency re-run
    invitePrefetchTeamIdRef.current = null;
  };
}, [teamOpen, numericTeamId, currentTeam, profile?.u_id]);

// Clear invite banner when modal closes
useEffect(() => {
  if (!teamOpen) {
    setInviteBanner(null);
  }
}, [teamOpen]);


  // DEBUG: mount/unmount tracing
  useEffect(() => {
    console.log('[TeamModal] MOUNT', instanceIdRef.current);
    console.trace('[TeamModal] MOUNT TRACE', instanceIdRef.current);

    return () => {
      console.log('[TeamModal] UNMOUNT', instanceIdRef.current);
      console.trace('[TeamModal] UNMOUNT TRACE', instanceIdRef.current);
    };
  }, []);

// Hydrate teammates on every open so:
// - incoming invite can evaluate roster BEFORE accept
// - captain/teammates see newest members without page refresh (clicking team is enough)
useEffect(() => {
  if (!teamOpen) return;
  if (!Number.isFinite(numericTeamId)) return;

  const isIncoming = inviteBanner?.mode === 'incoming';

  // Avoid refetch loops if the modal re-renders while still open,
  // but allow one fetch for "normal" and one fetch for "incoming"
  const prefetchKey = `${numericTeamId}:${isIncoming ? 'incoming' : 'normal'}`;

  if (invitePrefetchTeamIdRef.current === prefetchKey) return;
  invitePrefetchTeamIdRef.current = prefetchKey;


  let cancelled = false;

  (async () => {
    try {
      if (isIncoming) setBuildingTeammateCard(true);

      // 1) Force-refresh canonical member id list for this team (DB is source of truth)
      const idsRes = await ensureTeamMemberIds(numericTeamId, { force: true });

      const u_ids = Array.isArray(idsRes?.u_ids) ? idsRes.u_ids : [];
      if (cancelled) return;

      // 2) Hydrate user profiles for those member ids into otherUsersStore
      if (u_ids.length > 0) {
        await fetchUsersByIds(u_ids);
      }
    } catch (err) {
      console.error('[TeamModal] teammate hydration error:', err);
    } finally {
      if (!cancelled && isIncoming) {
        setBuildingTeammateCard(false);
      }
    }
  })();

  return () => {
    cancelled = true;
  };
}, [teamOpen, numericTeamId, inviteBanner, ensureTeamMemberIds, fetchUsersByIds]);

  // Team Reviews hydration (aggregate per teammate)
  useEffect(() => {
    if (!teamOpen) return;
    if (!Array.isArray(allTeamMemberIds) || allTeamMemberIds.length === 0) return;

    let cancelled = false;

    (async () => {
      try {
        const missingUserIds = allTeamMemberIds.filter((uid) => {
          const existing = teamReviewsByUserId?.[uid];
          return !Array.isArray(existing);
        });

        if (missingUserIds.length === 0) return;

        setTeamReviewsLoading(true);

        const results = await Promise.all(
          missingUserIds.map(async (uid) => {
            try {
              const res = await fetch(
                `/api/profile/${uid}/reviews`,
                { credentials: 'include' }
              );

              if (!res.ok) return { uid, reviews: [] };

              const data = await res.json();
              return { uid, reviews: Array.isArray(data) ? data : [] };
            } catch {
              return { uid, reviews: [] };
            }
          })
        );

        if (cancelled) return;

        setTeamReviewsByUserId((prev) => {
          const next = { ...(prev || {}) };
          for (const { uid, reviews } of results) {
            next[uid] = reviews;
          }
          return next;
        });
      } finally {
        if (!cancelled) setTeamReviewsLoading(false);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [teamOpen, allTeamMemberIds]);

  // Hot-reload roster while TeamModal is open (captain/teammates)
  // Keeps the teammate list fresh without a page refresh.
  useEffect(() => {
    if (!teamOpen) return;
    if (!Number.isFinite(numericTeamId)) return;

    // Do not poll during the incoming invite pre-accept screen
    if (inviteBanner?.mode === 'incoming') return;

    let cancelled = false;

    const tick = async () => {
      try {
        // Force-refresh canonical member id list for this team
        const idsRes = await ensureTeamMemberIds(numericTeamId, { force: true });
        const u_ids = Array.isArray(idsRes?.u_ids) ? idsRes.u_ids : [];
        if (cancelled) return;

        // Hydrate user profiles for those member ids
        if (u_ids.length > 0) {
          await fetchUsersByIds(u_ids);
        }
      } catch (err) {
        console.error('[TeamModal] hot-reload teammate polling error:', err);
      }
    };

    // Run once immediately, then poll
    tick();
    const intervalId = setInterval(tick, 5000);

    return () => {
      cancelled = true;
      clearInterval(intervalId);
    };
  }, [teamOpen, numericTeamId, inviteBanner, ensureTeamMemberIds, fetchUsersByIds]);


  if (!teamOpen) return null;

  // Prevent the first render from using Rnd's "default" sizing/positioning.
  // We always want the fixed getNormalRect() geometry on first open.
  if (!windowRect) return null;

  const onBackdropMouseDown = (e) => {
    // Windows-style stacking: TeamModal must NOT close on backdrop click.
    // Close is X-button only.
  };



  const acceptInvite = async () => {
    const invite_token = String(inviteBanner?.invite_token || '').trim();
    const invitee_u_id =
      Number(inviteBanner?.invitee_u_id) ||
      Number(profileUser?.u_id) ||
      null;

    if (!invite_token) {
      setInviteAcceptError('Missing invite token.');
      return;
    }

    if (!Number.isFinite(invitee_u_id)) {
      setInviteAcceptError('Missing invitee user id.');
      return;
    }

    setInviteAcceptError('');
    setInviteAcceptLoading(true);

    try {
      // 1) Persist accept in DB
      const res = await fetch('/api/teams/invite/accept', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ invite_token, invitee_u_id }),
      });

      const data = await res.json().catch(() => ({}));

      // Payment required — show upgrade modal instead of joining
      if (res.status === 402 && data.payment_required) {
        setPaymentGate(data);
        setInviteAcceptLoading(false);
        return;
      }

      if (!res.ok) {
        throw new Error(data?.error || `Accept failed (HTTP ${res.status}).`);
      }

// 1.5) Inject ONE explicit Matrix acceptance message (DM rooms are shared; per-user text is not possible without separate rooms)
      try {
        const payload = data?.matrix_notify_payload || null;
        const roomId = String(payload?.room_id || '').trim();

        const inviteeName =
          [profileUser?.u_first_name, profileUser?.u_last_name].filter(Boolean).join(' ').trim() ||
          (inviteBanner?.invitee_name ? String(inviteBanner.invitee_name).trim() : '') ||
          'A new member';

        const message = `${inviteeName} has joined the team ${teamName}.`;


        const effectiveService = mxService || getGlobalMatrixService();
        const effectiveClient = mxClient || getGlobalMatrixClient();

        const canSendViaService =
          effectiveService && typeof effectiveService.sendMessage === 'function';

        const canSendViaClient =
          effectiveClient && typeof effectiveClient.sendEvent === 'function';

        if (roomId && message && (canSendViaService || canSendViaClient)) {
          if (canSendViaService) {
            await effectiveService.sendMessage(roomId, message);
          } else {
            await effectiveClient.sendEvent(roomId, 'm.room.message', {
              msgtype: 'm.text',
              body: message,
            });
          }

          console.log('[TeamModal] Matrix accept message sent', {
            roomId,
            via: canSendViaService ? 'mxService.sendMessage' : 'mxClient.sendEvent',
          });
        } else {
          console.warn('[TeamModal] Matrix accept message deferred (missing room/sender/message)', {
            hasRoomId: Boolean(roomId),
            hasMessage: Boolean(message),
            hasMxService: Boolean(effectiveService),
            canSendViaService,
            hasMxClient: Boolean(effectiveClient),
            canSendViaClient,
          });

          if (roomId && message) {
            setPendingMatrixAccept({ room_id: roomId, message });
          }
        }
      } catch (err) {
        console.error('[TeamModal] Matrix accept message send failed', err);
      }



      // 2) Remove the banner driver so it does not persist across refresh/logins.
      try {
        localStorage.removeItem('eh_team_invite_banner');
      } catch {}


      // 3) Hide banner immediately, but DO NOT close modal
      setInviteBanner(null);
      setInviteAccepted(true);

      // 4) Start the “build teammate card” skeleton while we rehydrate teams from DB
      setBuildingTeammateCard(true);

      // Hydrate teams from server so membership persists across refresh/logout/login
      const teamsRes = await fetch(
        `/api/teams/recruiting/debug/my-teams?u_id=${invitee_u_id}`,
        { credentials: 'include' }
      );

      if (!teamsRes.ok) {
        throw new Error(`Failed to reload teams (HTTP ${teamsRes.status}).`);
      }

      const teamsJson = await teamsRes.json().catch(() => ({}));
      const teams = Array.isArray(teamsJson?.teams) ? teamsJson.teams : [];

      // Update store with server-truth list
      hydrateTeams(teams);

      // Step 3.6: force-refresh member ids + hydrate user profiles (DB is source of truth)
      if (Number.isFinite(numericTeamId)) {
        const idsRes = await ensureTeamMemberIds(numericTeamId, { force: true });

        if (idsRes?.ok && Array.isArray(idsRes.u_ids) && idsRes.u_ids.length > 0) {
          await fetchUsersByIds(idsRes.u_ids);
        }
      }

      // Re-fetch ratings/summary so member count, review count, and scores update immediately
      if (Number.isFinite(numericTeamId)) {
        try {
          const ratingRes = await fetch(
            `/api/teams/ratings/summary?team_id=${numericTeamId}`,
            { credentials: 'include' }
          );
          if (ratingRes.ok) {
            const rData = await ratingRes.json();
            const avg = rData?.team_avg != null ? parseFloat(rData.team_avg) : null;
            const count = Number(rData?.team_review_count) || 0;
            const mc = Number(rData?.member_count_total) || 0;
            setTeamRating({ avg: count > 0 ? avg : null, count, memberCount: mc });
          }
        } catch (err) {
          console.warn('[TeamModal] post-accept rating refresh failed:', err);
        }
      }

      // Make the accepted team active (teamId in modal is already the team being viewed)
      if (Number.isFinite(numericTeamId)) {
        setActiveTeamId(numericTeamId);
      }

    } catch (err) {
      console.error('[TeamModal] acceptInvite error:', err);
      setInviteAcceptError(String(err?.message || 'Accept failed.'));
      setInviteAccepted(false);
    } finally {
      setInviteAcceptLoading(false);
      setBuildingTeammateCard(false);
    }
  };

const declineInvite = async () => {
  const invite_token = String(inviteBanner?.invite_token || '').trim();
  const invitee_u_id =
    Number(inviteBanner?.invitee_u_id) ||
    Number(profileUser?.u_id) ||
    null;

  if (!invite_token) {
    setInviteAcceptError('Missing invite token.');
    return;
  }

  if (!Number.isFinite(invitee_u_id)) {
    setInviteAcceptError('Missing invitee user id.');
    return;
  }

  setInviteAcceptError('');
  setInviteDeclineLoading(true);

  try {
    const decline_reason = String(declineReason || '').trim() || null;

    const res = await fetch('/api/teams/invite/decline', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({ invite_token, invitee_u_id, decline_reason }),
    });

    const data = await res.json().catch(() => ({}));

    if (!res.ok) {
      throw new Error(data?.error || `Decline failed (HTTP ${res.status}).`);
    }

    // Matrix client-send (single line)
    try {
      const payload = data?.matrix_notify_payload || null;
      const roomId = String(payload?.room_id || '').trim();

      const inviteeName =
        [profileUser?.u_first_name, profileUser?.u_last_name].filter(Boolean).join(' ').trim() ||
        String(inviteBanner?.invitee_name || '').trim() ||
        'A member';

      const message = `${inviteeName} has declined to join the team ${teamName} at this time.`;

      const effectiveService = mxService || getGlobalMatrixService();
      const effectiveClient = mxClient || getGlobalMatrixClient();

      const canSendViaService =
        effectiveService && typeof effectiveService.sendMessage === 'function';

      const canSendViaClient =
        effectiveClient && typeof effectiveClient.sendEvent === 'function';

      if (roomId && message && (canSendViaService || canSendViaClient)) {
        if (canSendViaService) {
          await effectiveService.sendMessage(roomId, message);
        } else {
          await effectiveClient.sendEvent(roomId, 'm.room.message', {
            msgtype: 'm.text',
            body: message,
          });
        }

        console.log('[TeamModal] Matrix decline message sent', {
          roomId,
          via: canSendViaService ? 'mxService.sendMessage' : 'mxClient.sendEvent',
        });
      } else {
        console.warn('[TeamModal] Matrix decline message deferred (missing room/sender/message)', {
          hasRoomId: Boolean(roomId),
          hasMessage: Boolean(message),
          hasMxService: Boolean(effectiveService),
          canSendViaService,
          hasMxClient: Boolean(effectiveClient),
          canSendViaClient,
        });

        if (roomId && message) {
          setPendingMatrixAccept({ room_id: roomId, message });
        }
      }
    } catch (err) {
      console.error('[TeamModal] Matrix decline message send failed', err);
    }

    // Clear banner persistence
    try {
      localStorage.removeItem('eh_team_invite_banner');
    } catch {}

    // Reset decline UI and close
    setShowDeclineReason(false);
    setDeclineReason('');
    setInviteBanner(null);
    closeTeam();

  } catch (err) {
    console.error('[TeamModal] declineInvite error:', err);
    setInviteAcceptError(String(err?.message || 'Decline failed.'));
  } finally {
    setInviteDeclineLoading(false);
  }
};


  const commitInviteDecision = (decision) => {
    try {
      // TEMP audit trail (later: DB invite row + Matrix acknowledgement)
      localStorage.setItem(
        'eh_team_invite_last_decision',
        JSON.stringify({
          decision, // "accepted" | "declined"
          team_id: numericTeamId || null,
          team_name: teamName || null,
          at: Date.now(),
        })
      );

      // This is what drives the banner — remove it so it does not reappear
      localStorage.removeItem('eh_team_invite_banner');
    } catch {}

    // Hide banner immediately in this render cycle
    setInviteBanner(null);

    // Close modal (existing behavior)
    closeTeam();
  };

  return (
      <div
        style={{ zIndex: teamZ }}
        className="fixed inset-0 flex items-center justify-center pointer-events-none"
        aria-modal="true"
        role="dialog"
      >

      <Rnd
        // Fully controlled sizing/positioning — prevents occasional “elongated/off-screen” first opens.
        size={
          windowMode === 'max'
            ? { width: getMaxRect().width, height: getMaxRect().height }
            : { width: windowRect.width, height: windowRect.height }
        }
        position={
          windowMode === 'max'
            ? { x: getMaxRect().x, y: getMaxRect().y }
            : { x: windowRect.x, y: windowRect.y }
        }

        minWidth={320}
        minHeight={400}
        bounds="window"
        dragHandleClassName="eh-msg-header"
        disableDragging={windowMode === 'max'}
        enableResizing={
          windowMode === 'max'
            ? false
            : {
                bottomRight: true,
                bottomLeft: true,
                topRight: true,
                topLeft: true,
                left: true,
                right: true,
                bottom: true,
                top: true,
              }
        }
        onDragStop={(e, d) => {
          if (windowMode === 'max') return;
          setWindowRect((prev) => ({
            ...(prev || {}),
            x: d.x,
            y: d.y,
          }));
        }}
        onResizeStop={(e, direction, ref, delta, position) => {
          if (windowMode === 'max') return;
          setWindowRect({
            width: ref.offsetWidth,
            height: ref.offsetHeight,
            x: position.x,
            y: position.y,
          });
        }}
        className="rounded-2xl shadow-2xl overflow-hidden flex flex-col bg-white"
      >
        <div
          ref={modalRef}
          onMouseDownCapture={() => bringToFront('team')}
          onWheelCapture={(e) => {
            const scroller = e.target.closest('.eh-teammodal-scroll');
            // If wheel is not inside a TeamModal scroller, never let the page behind scroll.
            if (!scroller) {
              e.preventDefault();
              e.stopPropagation();
              return;
            }

            // If at scroll boundary, prevent scroll chaining into the background.
            const el = scroller;
            const atTop = el.scrollTop <= 0;
            const atBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 1;

            if ((e.deltaY < 0 && atTop) || (e.deltaY > 0 && atBottom)) {
              e.preventDefault();
              e.stopPropagation();
            }
          }}
          className="relative w-full h-full flex flex-col pointer-events-auto"
          aria-labelledby="team-modal-title"
        >



          {/* Header — brand blue, white text, draggable handle */}
          <div className="shrink-0 flex items-center justify-between px-4 sm:px-6 py-1 border-b border-[#00aef7] bg-[#00aef7] text-white cursor-move eh-msg-header">
            <div className="min-w-0">
              <h2
                id="team-modal-title"
                className="text-base sm:text-lg font-semibold tracking-tight truncate"
              >
                {teamName}

                {/* Recruiting Shortlist icon */}
                {(() => {
                  const isTeamMember = Array.isArray(allTeamMemberIds) &&
                    allTeamMemberIds.some(id => Number(id) === Number(profileUser?.u_id));

                  return (
                    <button
                      type="button"
                      className={`inline-flex items-center ml-2 pointer-events-auto ${
                        isTeamMember ? 'cursor-pointer' : 'cursor-not-allowed opacity-50'
                      }`}
                      aria-label="Recruiting Shortlist"
                      title={isTeamMember ? "Recruiting Shortlist" : "Only team members can access the recruiting list"}
                      disabled={!isTeamMember}
                      onMouseDown={(e) => {
                        e.stopPropagation();
                      }}
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        if (!isTeamMember) return;

                        // Set the team ID in recruiting store and open the modal
                        setRecruitingTeamId(numericTeamId);
                        openRecruiting();
                        bringToFront('recruiting');
                        console.log('[TeamModal] Recruiting icon clicked', { teamId: numericTeamId });
                      }}
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill={isTeamMember ? "#ffffff" : "#ffffff80"}>
                        <path d="M480-240Zm-320 80v-112q0-34 17.5-62.5T224-378q62-31 126-46.5T480-440q37 0 73 4.5t72 14.5l-67 68q-20-3-39-5t-39-2q-56 0-111 13.5T260-306q-9 5-14.5 14t-5.5 20v32h240v80H160Zm400 40v-123l221-220q9-9 20-13t22-4q12 0 23 4.5t20 13.5l37 37q8 9 12.5 20t4.5 22q0 11-4 22.5T903-340L683-120H560Zm300-263-37-37 37 37ZM620-180h38l121-122-18-19-19-18-122 121v38Zm141-141-19-18 37 37-18-19ZM367-527q-47-47-47-113t47-113q47-47 113-47t113 47q47 47 47 113t-47 113q-47 47-113 47t-113-47Zm169.5-56.5Q560-607 560-640t-23.5-56.5Q513-720 480-720t-56.5 23.5Q400-673 400-640t23.5 56.5Q447-560 480-560t56.5-23.5ZM480-640Z"/>
                      </svg>
                    </button>
                  );
                })()}

                {/* Profession Checker icon (opens overlay modal) */}
                <button
                  type="button"
                  className="inline-flex items-center ml-[10px] cursor-pointer pointer-events-auto"
                  aria-label="Open Profession Checker"
                  onMouseDown={(e) => {
                    // Prevent the header drag-handle from eating the click
                    e.stopPropagation();
                  }}
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    setProfessionCheckerOpen(true);
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#ffffff"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                    <path d="M20 11a8.1 8.1 0 0 0 -6.986 -6.918a8.095 8.095 0 0 0 -8.019 3.918" />
                    <path d="M4 13a8.1 8.1 0 0 0 15 3" />
                    <path d="M19 16m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
                    <path d="M5 8m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
                    <path d="M12 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0" />
                  </svg>
                </button>

              {/* View Public Team Profile icon - positioned left of window controls */}
              <button
                type="button"
                className="inline-flex items-center justify-center rounded-md px-2 py-1 text-white hover:bg-white/15 mr-[150px]"
                aria-label="View the Public Team Profile"
                title="View the Public Team Profile"
                onMouseDown={(e) => {
                  e.stopPropagation();
                }}
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();

                  const slug = String(teamSlug || '').trim();
                  const fallback = String(numericTeamId || '').trim();

                  const publicSite = process.env.REACT_APP_PUBLIC_SITE_ORIGIN
                    || (process.env.NODE_ENV === 'development' ? 'http://localhost:3020' : 'https://www.ehandshake.com');
                  const url = slug
                    ? `${publicSite}/userprofiles/teams/${encodeURIComponent(slug)}`
                    : `${publicSite}/userprofiles/teams/${encodeURIComponent(fallback)}`;

                  console.log('[TeamModal] public team icon click', { teamSlug: slug, numericTeamId, url });

                  window.open(url, '_blank', 'noopener,noreferrer');
                }}
              >
                <img
                  src="/images/PublicTeamIcon.png"
                  alt=""
                  className="h-5 w-6"
                  draggable={false}
                />
              </button>

              </h2>

            </div>
            <div className="flex items-center gap-1">
              {/* Maximize / Restore toggle */}
              <button
                type="button"
                onClick={toggleMaximize}
                className="inline-flex items-center justify-center rounded-md px-2 py-1 text-white hover:bg-white/15"
                aria-label={windowMode === 'max' ? 'Restore Down' : 'Maximize'}
                title={windowMode === 'max' ? 'Restore Down' : 'Maximize'}
              >
                □
              </button>

              {/* Close */}
              <button
                type="button"
                onClick={closeTeam}
                className="inline-flex items-center justify-center rounded-md px-2 py-1 text-white hover:bg-white/15"
                aria-label="Close"
                title="Close"
              >
                ✕
              </button>
            </div>

          </div>
          {professionCheckerOpen && (
            <ProfessionChecker
              teamId={numericTeamId}
              teammates={rosterForProfessionChecker}
              isCaptain={String(profileUser?.u_id) === String(captainId)}
              onAskTeam={handleAskTeam}
              onClose={() => setProfessionCheckerOpen(false)}
            />
          )}



          {/* Payment gate modal — shown when subscription required to join */}
          {paymentGate && (
            <div className="shrink-0 px-4 sm:px-6 py-4 bg-amber-50 border-b border-amber-200">
              <div className="flex flex-col gap-3">
                <div className="text-sm font-semibold text-gray-800">
                  {paymentGate.required_tier === 'additional_team'
                    ? 'Additional team membership required'
                    : 'Team membership subscription required'}
                </div>
                <p className="text-xs text-gray-600">
                  {paymentGate.required_tier === 'additional_team'
                    ? 'You\'re already on a team. Joining another team requires an additional subscription.'
                    : paymentGate.current_tier === 'first_string'
                      ? 'Upgrade from First String to Team Member to join this team. Your remaining balance will be credited.'
                      : 'Joining a team requires a Team Member subscription.'}
                </p>
                <div className="flex items-center gap-2">
                  <button
                    onClick={async () => {
                      const tier = paymentGate.required_tier;
                      const API_URL = process.env.REACT_APP_API_URL || '';
                      try {
                        const res = await fetch(`${API_URL}/api/subscription/create-checkout`, {
                          method: 'POST', credentials: 'include',
                          headers: { 'Content-Type': 'application/json' },
                          body: JSON.stringify({
                            tier, interval: 'month',
                            teamId: paymentGate.team_id,
                            inviteToken: paymentGate.invite_token,
                          }),
                        });
                        const data = await res.json();
                        if (data.ok && data.url) {
                          startPaymentPoll(paymentGate.invite_token, inviteBanner?.invitee_u_id || profileUser?.u_id, {
                            inviterUId: paymentGate.inviter_u_id,
                            inviteeName: [profileUser?.u_first_name, profileUser?.u_last_name].filter(Boolean).join(' ').trim(),
                            tName: teamName,
                          });
                          if (window.LemonSqueezy?.Url?.Open) window.LemonSqueezy.Url.Open(data.url);
                          else window.open(data.url, '_blank');
                        }
                      } catch (err) { console.error('[TeamModal] checkout error:', err); }
                    }}
                    className="px-3 py-1.5 text-xs font-semibold text-white bg-[#00aef7] rounded-lg hover:bg-[#0099dd] transition-colors"
                  >
                    {paymentGate.required_tier === 'additional_team' ? 'Monthly — $9.99/mo' : 'Monthly — $49.99/mo'}
                  </button>
                  <button
                    onClick={async () => {
                      const tier = paymentGate.required_tier;
                      const API_URL = process.env.REACT_APP_API_URL || '';
                      try {
                        const res = await fetch(`${API_URL}/api/subscription/create-checkout`, {
                          method: 'POST', credentials: 'include',
                          headers: { 'Content-Type': 'application/json' },
                          body: JSON.stringify({
                            tier, interval: 'year',
                            teamId: paymentGate.team_id,
                            inviteToken: paymentGate.invite_token,
                          }),
                        });
                        const data = await res.json();
                        if (data.ok && data.url) {
                          startPaymentPoll(paymentGate.invite_token, inviteBanner?.invitee_u_id || profileUser?.u_id, {
                            inviterUId: paymentGate.inviter_u_id,
                            inviteeName: [profileUser?.u_first_name, profileUser?.u_last_name].filter(Boolean).join(' ').trim(),
                            tName: teamName,
                          });
                          if (window.LemonSqueezy?.Url?.Open) window.LemonSqueezy.Url.Open(data.url);
                          else window.open(data.url, '_blank');
                        }
                      } catch (err) { console.error('[TeamModal] checkout error:', err); }
                    }}
                    className="px-3 py-1.5 text-xs font-semibold text-white bg-[#0077cc] rounded-lg hover:bg-[#006ab5] transition-colors"
                  >
                    {paymentGate.required_tier === 'additional_team' ? 'Annual — $107.89/yr' : 'Annual — $539.89/yr'} <span className="opacity-75">(save 10%)</span>
                  </button>
                  <button
                    onClick={() => setPaymentGate(null)}
                    className="px-3 py-1.5 text-xs font-medium text-gray-500 hover:text-gray-700 transition-colors"
                  >
                    Maybe later
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* Incoming invite banner (TEMP scaffolding) */}
          {inviteBanner?.mode === 'incoming' && !paymentGate && (
            <div className="shrink-0 px-4 sm:px-6 py-2 bg-[#00aef7]/10 border-b border-[#00aef7]/25">
              <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
                <div className="text-sm text-gray-800">
                  You’ve been invited to join the business team{' '}
                  <span className="font-semibold">{teamName}</span>.
                  {inviteAcceptError ? (
                    <div className="mt-1 text-xs text-red-600">
                      {inviteAcceptError}
                    </div>
                  ) : null}

                  {showDeclineReason ? (
                    <div className="mt-2">
                      <div className="text-xs text-gray-600 mb-1">
                        Optional: tell us why you’re declining
                      </div>
                      <textarea
                        value={declineReason}
                        onChange={(e) => setDeclineReason(e.target.value)}
                        rows={2}
                        className="w-full rounded-md border border-gray-300 bg-white px-2 py-1 text-sm text-gray-900 focus:outline-none focus:ring-2 focus:ring-[#00aef7]/50"
                        placeholder="Type a short reason (optional)"
                      />
                    </div>
                  ) : null}

                </div>


                <div className="flex items-center gap-2">
                  {showDeclineReason ? (
                    <>
                      <button
                        type="button"
                        onClick={declineInvite}
                        disabled={inviteDeclineLoading}
                        className={
                          inviteDeclineLoading
                            ? "px-3 py-1.5 rounded-md text-sm font-semibold bg-gray-400 text-white cursor-not-allowed"
                            : "px-3 py-1.5 rounded-md text-sm font-semibold bg-gray-700 text-white hover:bg-gray-800"
                        }
                      >
                        {inviteDeclineLoading ? 'Declining...' : 'Confirm Decline'}
                      </button>

                      <button
                        type="button"
                        onClick={() => {
                          setShowDeclineReason(false);
                          setDeclineReason('');
                          setInviteAcceptError('');
                        }}
                        className="px-3 py-1.5 rounded-md text... bg-white text-gray-500 border border-gray-200 hover:bg-gray-50"
                      >
                        Cancel
                      </button>
                    </>
                  ) : (
                    <>
                      <button
                        type="button"
                        onClick={acceptInvite}
                        disabled={inviteAcceptLoading}
                        className={
                          inviteAcceptLoading
                            ? "px-3 py-1.5 rounded-md text-sm font-semibold bg-[#00aef7]/60 text-white cursor-not-allowed"
                            : "px-3 py-1.5 rounded-md text-sm font-semibold bg-[#00aef7] text-white hover:bg-[#0097d6]"
                        }
                      >
                        {inviteAcceptLoading ? 'Accepting...' : 'Accept'}
                      </button>

                      <button
                        type="button"
                        onClick={() => {
                          setInviteAcceptError('');
                          setShowDeclineReason(true);
                        }}
                        className="px-3 py-1.5 rounded-md text... bg-white text-gray-700 border border-gray-300 hover:bg-gray-50"
                      >
                        Decline
                      </button>

                      <button
                        type="button"
                        onClick={closeTeam}
                        className="px-3 py-1.5 rounded-md text... bg-white text-gray-500 border border-gray-200 hover:bg-gray-50"
                      >
                        Maybe
                      </button>
                    </>
                  )}
                </div>
              </div>
            </div>
          )}
          {/* Body — 3 columns: captain / teammate cards / reviews + activity */}
          <div className="flex-1 min-h-0 overflow-hidden p-4">
            <div className="h-full">
              <div className="grid grid-cols-1 md:grid-cols-[24fr_48fr_28fr] gap-3 h-full">
                {/* Left Column — Captain + team stats */}
                <div className="min-w-0 box-border flex flex-col gap-3">
                  <div
                    className="bg-white rounded-lg p-4"
                    style={{
                      boxShadow: '0 4px 12px -2px rgba(0, 174, 247, 0.25), 0 2px 4px -1px rgba(0, 174, 247, 0.15), inset 0 -8px 12px -8px rgba(0, 174, 247, 0.1)',
                      border: '1px solid rgba(0, 174, 247, 0.2)',
                      borderBottomColor: 'rgba(0, 174, 247, 0.35)',
                      borderBottomWidth: '2px'
                    }}
                  >
                    <h3 className="text-sm font-semibold text-[#00aef7] mb-3 text-center">
                      Team Captain
                    </h3>

                    {/* Captain Profile Picture */}
                    <div
                      className="relative w-20 h-20 round...-full overflow-hidden cursor-pointer mx-auto"
                      onClick={async () => {
                        const id = Number(captainId);
                        if (!Number.isFinite(id)) return;

                        // ✅ Self-click (captain clicking self)
                        if (Number(profileUser?.u_id) === id) {
                          const selfCandidate = {
                            ...profileUser,
                            b_industry: profileUser?.b_business_industry || '',
                          };

                          openCandidate({
                            candidate: selfCandidate,
                            viewerUId,
                            top: 90,
                            right: 30,
                            offsetRight: 0,
                          });
                          return;
                        }

                        // ✅ Other user clicking captain
                        const richFromLocalUsers =
                          (Array.isArray(nearbyUsers)
                            ? nearbyUsers.find((u) => Number(u?.u_id) === id)
                            : null) || null;

                        openCandidate({
                          candidate: richFromLocalUsers || { u_id: id },
                          viewerUId,
                          top: 90,
                          right: 30,
                          offsetRight: 0,
                        });
                      }}
                    >

                      <div className="relative w-20 h-20 rounded-full items-center overflow-hidden border border-[#00aef7]/40 bg-gray-100">
                        {captainProfile ? (
                          <img
                            src={captainProfile}
                            alt={captainName}
                            className="w-full h-full object-cover"
                          />
                        ) : (
                          <div className="w-full h-full flex items-center justify-center text-gray-400 text-sm">
                            No Image
                          </div>
                        )}
                      </div>
                    </div>

                    {/* Captain Name */}
                    <p className="text-center text-[15px] font-semibold text-gray-900 truncate">
                      {captainName}
                    </p>

                    {/* Industry */}
                    <p className="text-center text-xs text-gray-500 truncate">
                      {industry}
                    </p>

                    {/* Team stats: captain-based team score + stars + member count */}
                    <div className="mt-4 border-t border-gray-100 pt-3 space-y-2 text-xs text-gray-700">
                      {/* Team Score + reviews + stars (stacked, centered like userprofile) */}
                      <div className="flex flex-col items-center gap-1">
                        {/* Title */}
                        <span className="font-medium text-[13px]">Team Score</span>

                        {/* Numeric rating + review count */}
                        {teamRating.avg != null ? (
                          <>
                            <div className="flex items-baseline gap-1">
                              <span className="text-[15px] font-semibold text-[#00aef7]">
                                {teamRating.avg.toFixed(2)}
                              </span>
                              <span className="text-[11px] text-gray-500">
                                ({teamRating.count}{' '}
                                {teamRating.count === 1 ? 'review' : 'reviews'})
                              </span>
                            </div>

                            {/* Stars row */}
                            <div className="flex">
                              {Array.from({ length: starCount }).map((_, index) => (
                                <span
                                  key={index}
                                  className={
                                    index < activeStars
                                      ? 'text-yellow-400 text-xs'
                                      : 'text-gray-300 text-xs'
                                  }
                                >
                                  ★
                                </span>
                              ))}
                            </div>
                          </>
                        ) : (
                          <span className="text-[11px] text-gray-500">
                            No reviews yet
                          </span>
                        )}
                      </div>

                      {/* Members count (captain-only for now) */}
                      <div className="flex items-center justify-between">
                        <span className="font-medium">Members</span>
                        <span className="font-semibold">
                          {teamRating.memberCount}
                        </span>
                      </div>
                    </div>
                  </div>


                  {/* Social Channels — captain's connected platforms */}
                  <div
                    className="bg-white rounded-lg p-4"
                    style={{
                      boxShadow: '0 4px 12px -2px rgba(0, 174, 247, 0.25), 0 2px 4px -1px rgba(0, 174, 247, 0.15), inset 0 -8px 12px -8px rgba(0, 174, 247, 0.1)',
                      border: '1px solid rgba(0, 174, 247, 0.2)',
                      borderBottomColor: 'rgba(0, 174, 247, 0.35)',
                      borderBottomWidth: '2px'
                    }}
                  >
                    <p className="text-xs text-gray-500 text-center mb-2">Social Channels</p>
                    {/* First Row - 3 icons */}
                    <div className="flex justify-center space-x-3 mb-2">
                      {/* Facebook */}
                      <svg className="w-8 h-8 transition-colors" fill={captainSocialPlatforms.includes('facebook') ? '#1877F2' : '#9ca3af'} viewBox="0 0 24 24">
                        <path d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z"/>
                      </svg>

                      {/* X/Twitter */}
                      <svg className="w-8 h-8 transition-colors" fill={captainSocialPlatforms.includes('twitter') ? '#000000' : '#9ca3af'} viewBox="0 0 24 24">
                        <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
                      </svg>

                      {/* YouTube */}
                      <svg className="w-8 h-8 transition-colors" fill={captainSocialPlatforms.includes('youtube') ? '#FF0000' : '#9ca3af'} viewBox="0 0 24 24">
                        <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
                      </svg>
                    </div>

                    {/* Second Row - 3 icons */}
                    <div className="flex justify-center space-x-3">
                      {/* LinkedIn */}
                      <svg className="w-8 h-8 transition-colors" fill={captainSocialPlatforms.includes('linkedin') ? '#0A66C2' : '#9ca3af'} viewBox="0 0 24 24">
                        <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                      </svg>

                      {/* TikTok */}
                      <svg className="w-8 h-8 transition-colors" fill={captainSocialPlatforms.includes('tiktok') ? '#000000' : '#9ca3af'} viewBox="0 0 24 24">
                        <path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z"/>
                      </svg>

                      {/* Instagram */}
                      <svg className="w-8 h-8 transition-colors" fill={captainSocialPlatforms.includes('instagram') ? '#E4405F' : '#9ca3af'} viewBox="0 0 24 24">
                        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                      </svg>
                    </div>
                  </div>

                  {/* Later: additional small cards (tags, service area, etc.) */}
                </div>

                {/* Middle Column — Teammate cards */}
                <div className="bg-white rounded-lg shadow-[0_0_20px_rgba(0,0,150,0.1)] h-full min-h-0 flex flex-col">
                  <h3 className="text-sm font-semibold text-center text-[#00aef7] mb-3 px-3 pt-3">
                    Teammates
                  </h3>

                  <div className="min-h-0 flex-1 overflow-y-auto overscroll-contain px-3 pb-3 scrollbar-thin scrollbar-track-transparent scrollbar-thumb-gray-100">
                    <div className="grid grid-cols-2 md:grid-cols-3 gap-3 auto-rows-fr">
                      {buildingTeammateCard ? (
                        <>
                          {Array.from({ length: 3 }).map((_, i) => (
                            <div
                              key={`skeleton-${i}`}
                              className="rounded-lg p-2 flex flex-col items-center justify-between text-center text-xs bg-white animate-pulse"
                              style={{
                                border: '1px solid rgba(0, 174, 247, 0.25)',
                                borderBottomWidth: '2px',
                                boxShadow: '0 2px 4px -1px rgba(0, 174, 247, 0.15), inset 0 -6px 8px -6px rgba(0, 174, 247, 0.12)',
                              }}
                            >
                              <div className="w-16 h-16 rounded-full bg-gray-200 mb-2" />
                              <div className="w-full space-y-2">
                                <div className="h-3 bg-gray-200 rounded w-3/4 mx-auto" />
                                <div className="h-3 bg-gray-200 rounded w-1/2 mx-auto" />
                              </div>
                            </div>
                          ))}
                        </>
                      ) : teamMembers.length > 0 ? (
                        <>
                          {teamMembers.map((member) => {
                            const memberId = member?.u_id ?? member?.user_id ?? null;

                            const memberPhoto =
                              member?.u_profile_picture ||
                              member?.avatar ||
                              member?.profile_picture ||
                              '';

                            const memberFirst =
                              member?.first_name ||
                              member?.u_first_name ||
                              '';

                            const memberLast =
                              member?.last_name ||
                              member?.u_last_name ||
                              '';

                            const memberName =
                              (member?.full_name && String(member.full_name).trim()) ||
                              [memberFirst, memberLast].filter(Boolean).join(' ').trim() ||
                              '';

                            // Pull industry from the SAME rich store used by CandidateListModal
                            const richCandidate = getUser?.(Number(memberId));

                            const localUser =
                              (Array.isArray(nearbyUsers)
                                ? nearbyUsers.find((u) => Number(u?.u_id) === Number(memberId))
                                : null) || null;

                            const memberIndustry =
                              localUser?.b_business_industry ||
                              localUser?.b_industry ||
                              localUser?.business?.b_business_industry ||
                              localUser?.business?.b_industry ||
                              member?.b_business_industry ||
                              member?.b_industry ||
                              member?.industry ||
                              member?.business?.b_business_industry ||
                              member?.business?.b_industry ||
                              '';



                            // ✅ Instrument only when it's missing so we don't spam the console
                            if (!memberIndustry) {
                              console.log('[TeamModal teammate industry missing]', {
                                memberId,
                                memberName,
                                topLevel: {
                                  b_business_industry: member?.b_business_industry,
                                  b_industry: member?.b_industry,
                                  industry: member?.industry,
                                },
                                nestedBusiness: member?.business,
                                allKeys: member ? Object.keys(member) : [],
                              });
                            }



                            return (
                              <div
                                key={memberId || `${memberName}-${Math.random()}`}
                                role="button"
                                tabIndex={0}
                                onClick={async () => {
                                  const id = Number(memberId ?? member?.u_id ?? member?.user_id);
                                  if (!Number.isFinite(id)) return;

                                  // ✅ Self-click: use signed-in profile object (not in OtherUsers store)
                                  if (Number(profileUser?.u_id) === id) {
                                    // ✅ Ratings MUST come from the clicked team member object (profileUser usually does not carry them)
                                    const selfReviewCountRaw = Math.max(
                                      Number(profileUser?.u_review_count ?? 0) || 0,
                                      Number(member?.u_review_count ?? 0) || 0,
                                      Number(member?.review_count ?? 0) || 0,
                                      Number(member?.rating_count ?? 0) || 0
                                    );

                                    const selfAvgRatingRaw = Math.max(
                                      Number(profileUser?.u_avg_rating ?? 0) || 0,
                                      Number(member?.u_avg_rating ?? 0) || 0,
                                      Number(member?.avg_rating ?? 0) || 0,
                                      Number(member?.rating_avg ?? 0) || 0
                                    );


                                    const selfReviewCount = Number.isFinite(Number(selfReviewCountRaw))
                                      ? Number(selfReviewCountRaw)
                                      : 0;

                                    const selfAvgRating = Number.isFinite(Number(selfAvgRatingRaw))
                                      ? Number(selfAvgRatingRaw)
                                      : 0;

                                    const selfCandidate = {
                                      ...profileUser,

                                      // CandidateListModal expects b_industry
                                      b_industry: profileUser?.b_business_industry || '',

                                      // ✅ CandidateListModal reads these exact keys
                                      u_review_count: selfReviewCount,
                                      u_avg_rating: selfAvgRating,
                                    };
                                      console.log('[TeamModal self-click] id:', id);

                                      console.log('[TeamModal self-click] profileUser ratings:', {
                                        u_avg_rating: profileUser?.u_avg_rating,
                                        u_review_count: profileUser?.u_review_count,
                                        rating_avg: profileUser?.rating_avg,
                                        rating_count: profileUser?.rating_count,
                                      });

                                      console.log('[TeamModal self-click] member ratings:', {
                                        u_avg_rating: member?.u_avg_rating,
                                        u_review_count: member?.u_review_count,
                                        rating_avg: member?.rating_avg,
                                        rating_count: member?.rating_count,
                                      });

                                      try {
                                        const storeSelf = getUser?.(id);
                                        console.log('[TeamModal self-click] otherUsersStore.getUser(id):', {
                                          exists: !!storeSelf,
                                          u_avg_rating: storeSelf?.u_avg_rating,
                                          u_review_count: storeSelf?.u_review_count,
                                          rating_avg: storeSelf?.rating_avg,
                                          rating_count: storeSelf?.rating_count,
                                        });
                                      } catch (e) {
                                        console.log('[TeamModal self-click] getUser threw:', e);
                                      }

                                      console.log('[TeamModal self-click] selfCandidate ratings:', {
                                        u_avg_rating: selfCandidate?.u_avg_rating,
                                        u_review_count: selfCandidate?.u_review_count,
                                      });

                                    openCandidate({
                                      candidate: selfCandidate,
                                      viewerUId,
                                      top: 90,
                                      right: 30,
                                      offsetRight: 0,
                                    });
                                    return;
                                  }



                                  // Existing behavior: pull rich object from /teams/local-users when available
                                  const richFromLocalUsers =
                                    (Array.isArray(nearbyUsers)
                                      ? nearbyUsers.find((u) => Number(u?.u_id) === id)
                                      : null) || null;

                                  openCandidate({
                                    candidate: richFromLocalUsers || member,
                                    viewerUId,
                                    top: 90,
                                    right: 30,
                                    offsetRight: 0,
                                  });
                                }}



                                onKeyDown={async (e) => {
                                  if (e.key !== 'Enter') return;

                                  const id = Number(memberId ?? member?.u_id ?? member?.user_id);
                                  if (!Number.isFinite(id)) return;

                                  // Prefer cached candidate from global store
                                  let rich = getUser(id);

                                  // Fetch if we do not yet have the rich-by-ids payload (u_phone_number is our marker)
                                  const hasPhone =
                                    rich?.u_phone_number && String(rich.u_phone_number).trim();

                                  if (!rich || !hasPhone) {
                                    await fetchUsersByIds([id]);
                                    rich = getUser(id);
                                  }


                                  const normalizedCandidate = {
                                    ...member,
                                    u_id: id,
                                    u_first_name: memberFirst || member?.u_first_name || member?.first_name || '',
                                    u_last_name: memberLast || member?.u_last_name || member?.last_name || '',
                                    u_profile_picture: memberPhoto || member?.u_profile_picture || member?.avatar || member?.profile_picture || '',
                                    b_name:
                                      member?.b_name ||
                                      member?.business_name ||
                                      member?.b_business_name ||
                                      member?.business?.b_name ||
                                      '',
                                    b_business_industry: member?.b_business_industry || '',
                                  };

                                  openCandidate({
                                    candidate: rich || normalizedCandidate,
                                    viewerUId,
                                    top: 90,
                                    right: 30,
                                    offsetRight: 0,
                                  });
                                }}

                                className="rounded-lg p-2 flex flex-col items-center justify-between text-center text-xs text-gray-700 bg-white cursor-pointer hover:shadow-lg transition-shadow"
                                style={{
                                  border: '1px solid rgba(0, 174, 247, 0.25)',
                                  borderBottomWidth: '2px',
                                  boxShadow: '0 2px 4px -1px rgba(0, 174, 247, 0.15), inset 0 -6px 8px -6px rgba(0, 174, 247, 0.12)',
                                }}
                              >

                                <div className="w-16 h-16 rounded-full overflow-hidden border border-[#00aef7]/30 bg-gray-100 mb-2">
                                  {memberPhoto ? (
                                    <img
                                      src={`${process.env.REACT_APP_API_URL}${memberPhoto}`}
                                      alt=""
                                      className="w-full h-full object-cover"
                                    />
                                  ) : (
                                    <div className="w-full h-full flex items-center justify-center text-gray-400 text-[10px]">
                                      No Image
                                    </div>
                                  )}
                                </div>

                                <div className="space-y-0.5 w-full">
                                  <div className="font-semibold truncate">
                                    {memberName || 'Unknown'}
                                  </div>
                                  <div className="text-[11px] text-gray-500 truncate">
                                    {memberIndustry || ''}
                                  </div>
                                </div>
                              </div>
                            );
                          })}

                        </>
                      ) : (
                        <div className="col-span-full text-center text-xs text-gray-500 py-6">
                          No teammates yet.
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                {/* Right Column — Reviews + Activity (Design A: segmented switch) */}
                <div className="min-w-0 box-border flex flex-col h-full min-h-0">
                  <div className="bg-white rounded-lg shadow-[0_0_20px_rgba(0,0,150,0.1)] flex flex-col flex-1 min-h-0">

                    {/* Segmented header */}
                    <div className="px-3 pt-3">
                      <div className="w-full inline-flex rounded-md border border-[#00aef7]p-1">
                        <button
                          type="button"
                          onClick={() => setRightTab('reviews')}
                          className={[
                            "flex-1 rounded-md px-2 py-1.5 text-xs font-semibold transition",
                            isRightReviews
                              ? "bg-white text-[#00aef7] shadow-sm"
                              : "text-gray-600 hover:text-gray-900"
                          ].join(" ")}
                        >
                          Reviews
                        </button>

                        <button
                          type="button"
                          onClick={() => setRightTab('activity')}
                          className={[
                            "flex-1 rounded-md px-2 py-1.5 text-xs font-semibold transition",
                            isRightActivity
                              ? "bg-white text-[#00aef7] shadow-sm"
                              : "text-gray-600 hover:text-gray-900"
                          ].join(" ")}
                        >
                          Activity
                        </button>
                      </div>
                    </div>

                    {/* Body */}
                    <div
                      ref={isRightReviews ? teamReviewsScrollRef : teamActivityScrollRef}
                      className="mx-3 mb-3 mt-2 pl-3 pr-2 pt-2 flex-1 min-h-0 overflow-y-auto overscroll-contain rounded-lg scrollbar-thin scrollbar-thumb-gray-100 scrollbar-track-transparent"
                    >

                      {isRightReviews ? (
                        <div className="flex flex-col flex-1 min-h-0 overflow-hidden">
                          <div className="text-xs text-gray-600 flex flex-col flex-1 min-h-0 overflow-hidden">
                            {/* Reviews feed will render here (AllReviewsList) */}
                            <div
                              

                            >
                              <AllReviewsList
                                reviews={teamReviewsVisible}
                                hideControls
                                showReplyStatus={false}
                                getRevieweeLabel={(review) => {
                                  const uid = Number(review?.user_id);
                                  if (!Number.isFinite(uid) || uid <= 0) return '';

                                  const u = Number(profileUser?.u_id) === uid ? profileUser : getUser(uid);
                                  if (!u) return '';

                                  const first = String(u.first_name ?? u.u_first_name ?? '').trim();
                                  const last  = String(u.last_name ?? u.u_last_name ?? '').trim();
                                  const name  = [first, last].filter(Boolean).join(' ').trim();

                                  const industry = String(
                                    u.b_business_industry ??
                                    u.b_industry ??
                                    u.business?.b_business_industry ??
                                    u.business?.b_industry ??
                                    u.company?.b_business_industry ??
                                    u.company?.b_industry ??
                                    u.industry ??
                                    ''
                                  ).trim();

                                  if (!name && !industry) return '';
                                  return industry ? `${name} – ${industry}` : name;
                                }}
                              />

                              {/* Sentinel for infinite scroll */}
                              {teamReviewsVisibleCount < teamReviewsSorted.length && (
                                <div ref={teamReviewsSentinelRef} className="h-6" />
                              )}
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div className="flex flex-col flex-1 min-h-0">
                          <div className="text-xs text-gray-600 space-y-2">
                            <p className="text-gray-900 font-semibold">
                              Team Activity
                            </p>

                            {teamActivityEvents.length === 0 && !teamActivityLoading && (
                              <p className="text-gray-500">
                                No activity yet.
                              </p>
                            )}

                              <div className="space-y-4 pr-2 pb-6">
                                {teamActivityEvents.map((ev, i) => {
                                  const actorId = Number(ev?.actor_u_id);
                                  const actor =
                                    Number(profileUser?.u_id) === actorId ? profileUser : getUser(actorId);

                                  const first = String(actor?.first_name ?? actor?.u_first_name ?? '').trim();
                                  const last = String(actor?.last_name ?? actor?.u_last_name ?? '').trim();
                                  const actorNameStr = [first, last].filter(Boolean).join(' ').trim() || 'Someone';

                                  // Clickable actor name — opens CandidateListModal for the sharer
                                  // Always fetch fresh data to ensure logo/profile changes are reflected
                                  const handleActorClick = async () => {
                                    let rich = null;
                                    try {
                                      const res = await fetch(
                                        `${process.env.REACT_APP_API_URL}/api/teams/users/by-ids?ids=${actorId}`,
                                        { credentials: 'include' }
                                      );
                                      const data = await res.json();
                                      if (data.users?.length) rich = data.users[0];
                                    } catch {}
                                    if (rich || actor) {
                                      openCandidate({
                                        candidate: rich || actor,
                                        viewerUId: Number(profileUser?.u_id),
                                        top: 90,
                                        right: 30,
                                        offsetRight: 0,
                                      });
                                    }
                                  };

                                  const actorName = (
                                    <button
                                      type="button"
                                      onClick={handleActorClick}
                                      className="font-medium text-gray-800 hover:text-[#00aef7] hover:underline cursor-pointer bg-transparent border-none p-0 m-0 inline text-left"
                                      style={{ fontSize: 'inherit', lineHeight: 'inherit' }}
                                    >
                                      {actorNameStr}
                                    </button>
                                  );

                                  const when = ev?.occurred_at ? new Date(ev.occurred_at) : null;
                                  const whenLabel =
                                    when && !isNaN(when.getTime())
                                      ? when.toLocaleDateString('en-US', {
                                          month: 'short',
                                          day: 'numeric',
                                          year: 'numeric',
                                        })
                                      : 'Unknown Date';

                                  // Format message based on event type
                                  const payload = ev?.payload || {};
                                  let message;
                                  let borderColor = '#9CA3AF'; // default gray
                                  let bgTint = '#9CA3AF18';   // subtle background tint

                                  // Platform brand colors for left border accent
                                  const PLATFORM_COLORS = {
                                    email:     '#00aef7', // eHandshake brand blue
                                    facebook:  '#1877F2', // Facebook blue
                                    instagram: '#E4405F', // Instagram pink/red
                                    youtube:   '#FF0000', // YouTube red
                                    linkedin:  '#0A66C2', // LinkedIn blue
                                    x:         '#000000', // X/Twitter black
                                    twitter:   '#000000',
                                    pinterest: '#E60023', // Pinterest red
                                    tiktok:    '#ff0050', // TikTok red
                                  };

                                  // Platform display names
                                  const PLATFORM_LABELS = {
                                    email:     'email',
                                    facebook:  'Facebook',
                                    instagram: 'Instagram',
                                    youtube:   'YouTube',
                                    linkedin:  'LinkedIn',
                                    x:         'X',
                                    twitter:   'X',
                                    pinterest: 'Pinterest',
                                    tiktok:    'TikTok',
                                  };

                                  // Small platform icons (16×16) for activity feed
                                  const PLATFORM_ICONS = {
                                    email: (
                                      <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none">
                                        <rect x="2" y="4" width="20" height="16" rx="3" fill="#00aef7"/>
                                        <path d="M2 7l10 6 10-6" stroke="#fff" strokeWidth="2" fill="none"/>
                                      </svg>
                                    ),
                                    facebook: (
                                      <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none">
                                        <circle cx="12" cy="12" r="11" fill="#1877F2"/>
                                        <path d="M16.671 15.469l.547-3.469H13.89V9.938c0-.949.478-1.875 2.012-1.875H17.3V5.125s-1.239-.21-2.422-.21c-2.473 0-4.088 1.497-4.088 4.21V12H7.688v3.469h3.102V24h3.1V15.469h2.781z" fill="#fff"/>
                                      </svg>
                                    ),
                                    instagram: (
                                      <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none">
                                        <defs>
                                          <linearGradient id="igAct" x1="0" y1="24" x2="24" y2="0">
                                            <stop offset="0%" stopColor="#FFDC80"/>
                                            <stop offset="25%" stopColor="#F77737"/>
                                            <stop offset="50%" stopColor="#F56040"/>
                                            <stop offset="75%" stopColor="#C13584"/>
                                            <stop offset="100%" stopColor="#833AB4"/>
                                          </linearGradient>
                                        </defs>
                                        <rect x="1" y="1" width="22" height="22" rx="6" fill="url(#igAct)"/>
                                        <circle cx="12" cy="12" r="4.5" stroke="#fff" strokeWidth="2" fill="none"/>
                                        <circle cx="17.5" cy="6.5" r="1.2" fill="#fff"/>
                                      </svg>
                                    ),
                                    youtube: (
                                      <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none">
                                        <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" fill="#FF0000"/>
                                      </svg>
                                    ),
                                    linkedin: (
                                      <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none">
                                        <rect x="1" y="1" width="22" height="22" rx="4" fill="#0A66C2"/>
                                        <path d="M7.5 10v7M7.5 7v.01M10.5 17v-4c0-1.5 1-2.5 2.5-2.5s2 1 2 2.5v4M15 10v7" stroke="#fff" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
                                      </svg>
                                    ),
                                    x: (
                                      <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none">
                                        <circle cx="12" cy="12" r="11" fill="#000"/>
                                        <path d="M13.544 10.456L17.89 5.5h-1.3l-3.474 4.026L10.1 5.5H6l4.564 6.634L6 17.5h1.3l3.98-4.627L14.4 17.5H18.5l-4.956-7.044zm-1.41 1.636l-.46-.66L7.8 6.3h1.58l2.96 4.24.46.66L16.6 16.74h-1.58l-2.886-4.648z" fill="#fff"/>
                                      </svg>
                                    ),
                                    twitter: null, // uses x
                                    pinterest: (
                                      <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none">
                                        <circle cx="12" cy="12" r="11" fill="#E60023"/>
                                        <path d="M12 5.5c-3.59 0-6.5 2.91-6.5 6.5 0 2.63 1.57 4.9 3.82 5.92-.05-.48-.1-1.2.02-1.72.1-.47.68-2.87.68-2.87s-.17-.34-.17-.85c0-.8.46-1.39 1.04-1.39.49 0 .73.37.73.81 0 .49-.31 1.23-.48 1.92-.14.57.29 1.04.85 1.04 1.02 0 1.8-1.08 1.8-2.63 0-1.38-.99-2.34-2.4-2.34-1.64 0-2.6 1.23-2.6 2.5 0 .49.19.86.43 1.14.12.14.14.2.09.36-.03.12-.1.4-.13.51-.04.17-.15.23-.33.17-.91-.38-1.32-1.38-1.32-2.49 0-2.03 1.73-4.48 5.14-4.48 2.75 0 4.55 1.99 4.55 4.13 0 2.82-1.56 4.93-3.86 4.93-.77 0-1.5-.42-1.75-.89l-.5 1.96c-.16.59-.52 1.17-.81 1.63.69.2 1.41.31 2.16.31 3.59 0 6.5-2.91 6.5-6.5S15.59 5.5 12 5.5z" fill="#fff"/>
                                      </svg>
                                    ),
                                    tiktok: (
                                      <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none">
                                        <rect x="1" y="1" width="22" height="22" rx="6" fill="#000"/>
                                        <path d="M16.5 6.5c-.6-.5-1-1.3-1-2h-2v10.3c0 1.2-.9 2.2-2 2.2s-2-1-2-2.2c0-1.2.9-2.2 2-2.2.2 0 .5 0 .7.1v-2.1c-.2 0-.5-.1-.7-.1-2.3 0-4.2 1.9-4.2 4.3s1.9 4.3 4.2 4.3 4.2-1.9 4.2-4.3V10c.8.6 1.8.9 2.8.9v-2c-.7 0-1.4-.3-2-.9z" fill="#fff"/>
                                        <path d="M16.5 6.5c-.6-.5-1-1.3-1-2h-2v10.3c0 1.2-.9 2.2-2 2.2" stroke="#25F4EE" strokeWidth=".5" fill="none" opacity=".7"/>
                                        <path d="M13.5 4.5v10.3c0 1.2-.9 2.2-2 2.2s-2-1-2-2.2" stroke="#FE2C55" strokeWidth=".5" fill="none" opacity=".7"/>
                                      </svg>
                                    ),
                                  };
                                  // Alias twitter to x
                                  if (!PLATFORM_ICONS.twitter) PLATFORM_ICONS.twitter = PLATFORM_ICONS.x;

                                  if (ev?.event_type === 'share') {
                                    const shareType = payload.share_type;
                                    const platform = payload.platform || 'email';
                                    const targetName = payload.target_name || '';
                                    const creationTitle = payload.creation_title || '';

                                    // Use platform brand color — solid for border, tinted for background
                                    const brandColor = PLATFORM_COLORS[platform] || '#00aef7';
                                    borderColor = brandColor;
                                    bgTint = brandColor + '18';

                                    const platformLabel = PLATFORM_LABELS[platform] || platform;
                                    const recipientCount = payload.recipient_count || 0;
                                    const viaText = platform === 'email'
                                      ? (recipientCount > 1 ? `shared by email with ${recipientCount} people` : 'shared by email')
                                      : `shared on ${platformLabel}`;
                                    const isFreeAgentActor = payload.is_free_agent === true;

                                    if (shareType === 'profile') {
                                      message = (
                                        <span>
                                          {actorName}
                                          {' shared '}
                                          <span className="font-medium text-gray-800">{targetName || 'a profile'}</span>
                                          {"'s profile, "}<span className="text-[11px] text-gray-400">{viaText}</span>
                                        </span>
                                      );
                                    } else if (shareType === 'company') {
                                      message = (
                                        <span>
                                          {actorName}
                                          {' shared '}
                                          <span className="font-medium text-gray-800">{targetName || 'a company'}</span>
                                          {"'s company profile, "}<span className="text-[11px] text-gray-400">{viaText}</span>
                                        </span>
                                      );
                                    } else if (shareType === 'creation') {
                                      // Resolve creation author name: payload.author_name, or look up target_u_id
                                      const authorUid = Number(payload.target_u_id);
                                      const authorUser =
                                        Number.isFinite(authorUid) && authorUid > 0
                                          ? (Number(profileUser?.u_id) === authorUid ? profileUser : getUser(authorUid))
                                          : null;
                                      const authorName =
                                        payload.author_name ||
                                        (authorUser
                                          ? [
                                              String(authorUser?.first_name ?? authorUser?.u_first_name ?? '').trim(),
                                              String(authorUser?.last_name ?? authorUser?.u_last_name ?? '').trim(),
                                            ].filter(Boolean).join(' ')
                                          : '');

                                      message = (
                                        <span>
                                          {actorName}
                                          {isFreeAgentActor && (
                                            <img src={`${process.env.PUBLIC_URL}/pricing/Whistle_badge.png`} alt="Free Agent" title="Free Agent" className="ml-1 inline-block w-3.5 h-3.5 align-middle" />
                                          )}
                                          {' shared the creation '}
                                          <span className="font-medium text-gray-800">"{creationTitle}"</span>
                                          {authorName ? (
                                            <>
                                              {', created by '}
                                              <span className="font-medium text-gray-800">{authorName}</span>
                                            </>
                                          ) : null}
                                          {', '}
                                          <span className="text-[11px] text-gray-400">{viaText}</span>
                                        </span>
                                      );
                                    } else if (shareType === 'team') {
                                      message = (
                                        <span>
                                          {actorName}
                                          {' shared the team, '}<span className="text-[11px] text-gray-400">{viaText}</span>
                                        </span>
                                      );
                                    } else {
                                      message = (
                                        <span>
                                          {actorName}
                                          {' shared something, '}<span className="text-[11px] text-gray-400">{viaText}</span>
                                        </span>
                                      );
                                    }
                                  } else if (ev?.event_type === 'engagement') {
                                    const platform = payload.platform || 'facebook';
                                    const brandColor = PLATFORM_COLORS[platform] || '#00aef7';
                                    borderColor = brandColor;
                                    bgTint = brandColor + '18';
                                    const platformLabel = PLATFORM_LABELS[platform] || platform;
                                    const metricLabel =
                                      payload.metric === 'likes' ? (payload.milestone === 1 ? 'like' : 'likes')
                                      : payload.metric === 'comments' ? (payload.milestone === 1 ? 'comment' : 'comments')
                                      : payload.metric === 'views' ? 'views'
                                      : payload.metric;
                                    let subject;
                                    if (payload.share_type === 'creation') {
                                      subject = (
                                        <>
                                          {payload.author_name ? <span className="font-medium text-gray-800">{payload.author_name}</span> : actorName}
                                          {"'s post "}
                                          <span className="font-medium text-gray-800">"{payload.creation_title || '(untitled)'}"</span>
                                        </>
                                      );
                                    } else if (payload.share_type === 'profile') {
                                      subject = (
                                        <>
                                          {actorName}
                                          {"'s share of "}
                                          <span className="font-medium text-gray-800">{payload.target_name || 'a profile'}</span>
                                        </>
                                      );
                                    } else if (payload.share_type === 'company') {
                                      subject = (
                                        <>
                                          {actorName}
                                          {"'s share of "}
                                          <span className="font-medium text-gray-800">{payload.target_name || 'a company'}</span>
                                        </>
                                      );
                                    } else {
                                      subject = (
                                        <>
                                          {actorName}
                                          {"'s share of "}
                                          <span className="font-medium text-gray-800">{payload.target_name || 'a team'}</span>
                                        </>
                                      );
                                    }
                                    message = (
                                      <span>
                                        🎉 {subject}{' just hit '}
                                        <span className="font-semibold text-gray-800">{payload.milestone.toLocaleString()} {metricLabel}</span>
                                        {' on '}
                                        <span className="font-medium" style={{ color: brandColor }}>{platformLabel}</span>
                                        {payload.post_url ? (
                                          <>
                                            {' — '}
                                            <a
                                              href={payload.post_url}
                                              target="_blank"
                                              rel="noopener noreferrer"
                                              className="underline"
                                              style={{ color: brandColor }}
                                              onClick={(e) => e.stopPropagation()}
                                            >
                                              view post
                                            </a>
                                          </>
                                        ) : null}
                                      </span>
                                    );
                                  } else {
                                    // team_join (default)
                                    borderColor = '#10B981'; // green for joins
                                    bgTint = '#10B98118';
                                    message = (
                                      <span>
                                        {actorName}
                                        {' joined '}
                                        <span className="font-medium text-gray-800">{teamName}</span>
                                      </span>
                                    );
                                  }

                                  // Determine the icon for this event
                                  const platformKey = (ev?.event_type === 'share' || ev?.event_type === 'engagement')
                                    ? (payload.platform || 'email')
                                    : null;
                                  const platformIcon = platformKey ? PLATFORM_ICONS[platformKey] : null;
                                  const engagementPostUrl = ev?.event_type === 'engagement' ? payload.post_url : null;

                                  return (
                                    <div key={String(ev?.event_id ?? `${i}`)} className="border-b border-gray-100 pb-3">
                                      <div className="flex justify-between items-center">
                                        <div className="flex items-center gap-1">
                                          {platformIcon || (
                                            /* Person-plus icon for team joins */
                                            <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none">
                                              <circle cx="12" cy="12" r="11" fill="#10B981"/>
                                              <circle cx="10" cy="9" r="2.5" fill="#fff"/>
                                              <path d="M5.5 17.5c0-2.5 2-4.5 4.5-4.5s4.5 2 4.5 4.5" stroke="#fff" strokeWidth="1.8" strokeLinecap="round" fill="none"/>
                                              <path d="M17 10v4M15 12h4" stroke="#fff" strokeWidth="1.8" strokeLinecap="round"/>
                                            </svg>
                                          )}
                                        </div>
                                        <p className="text-[11px] text-gray-400">
                                          {whenLabel}
                                        </p>
                                      </div>
                                      <div
                                        className={`relative mt-2 rounded-lg ${engagementPostUrl ? 'cursor-pointer hover:brightness-95' : ''}`}
                                        style={{
                                          borderLeft: `4px solid ${borderColor}`,
                                          backgroundColor: bgTint,
                                        }}
                                        onClick={engagementPostUrl ? () => window.open(engagementPostUrl, '_blank', 'noopener,noreferrer') : undefined}
                                      >
                                        <p className="text-xs text-gray-600 p-2 rounded min-h-[30px]">
                                          {message}
                                        </p>
                                      </div>
                                    </div>
                                  );
                                })}
                              </div>


                            {/* Sentinel for infinite scroll */}
                            {teamActivityHasMore && (
                              <div ref={teamActivitySentinelRef} className="h-6" />
                            )}

                            {teamActivityLoading && (
                              <div className="text-[11px] text-gray-500 pt-1">
                                Loading…
                              </div>
                            )}
                          </div>
                        </div>
                      )}

                    </div>
                  </div>
                </div>


              </div>
            </div>
          </div>

        </div>
      </Rnd>
    </div>
  );
}

